export default [
    {
        "stationName": "Abbey Wood",
        "crs": "ABW"
    },
    {
        "stationName": "Aber",
        "crs": "ABE"
    },
    {
        "stationName": "Abercynon",
        "crs": "ACY"
    },
    {
        "stationName": "Aberdare",
        "crs": "ABA"
    },
    {
        "stationName": "Aberdeen",
        "crs": "ABD"
    },
    {
        "stationName": "Aberdour",
        "crs": "AUR"
    },
    {
        "stationName": "Aberdovey",
        "crs": "AVY"
    },
    {
        "stationName": "Abererch",
        "crs": "ABH"
    },
    {
        "stationName": "Abergavenny",
        "crs": "AGV"
    },
    {
        "stationName": "Abergele & Pensarn",
        "crs": "AGL"
    },
    {
        "stationName": "Aberystwyth",
        "crs": "AYW"
    },
    {
        "stationName": "Accrington",
        "crs": "ACR"
    },
    {
        "stationName": "Achanalt",
        "crs": "AAT"
    },
    {
        "stationName": "Achnasheen",
        "crs": "ACN"
    },
    {
        "stationName": "Achnashellach",
        "crs": "ACH"
    },
    {
        "stationName": "Acklington",
        "crs": "ACK"
    },
    {
        "stationName": "Acle",
        "crs": "ACL"
    },
    {
        "stationName": "Acocks Green",
        "crs": "ACG"
    },
    {
        "stationName": "Acton Bridge (Cheshire)",
        "crs": "ACB"
    },
    {
        "stationName": "Acton Central",
        "crs": "ACC"
    },
    {
        "stationName": "Acton Main Line",
        "crs": "AML"
    },
    {
        "stationName": "Adderley Park",
        "crs": "ADD"
    },
    {
        "stationName": "Addiewell",
        "crs": "ADW"
    },
    {
        "stationName": "Addlestone",
        "crs": "ASN"
    },
    {
        "stationName": "Adisham",
        "crs": "ADM"
    },
    {
        "stationName": "Adlington (Cheshire)",
        "crs": "ADC"
    },
    {
        "stationName": "Adlington (Lancs)",
        "crs": "ADL"
    },
    {
        "stationName": "Adwick",
        "crs": "AWK"
    },
    {
        "stationName": "Aigburth",
        "crs": "AIG"
    },
    {
        "stationName": "Ainsdale",
        "crs": "ANS"
    },
    {
        "stationName": "Aintree",
        "crs": "AIN"
    },
    {
        "stationName": "Airbles",
        "crs": "AIR"
    },
    {
        "stationName": "Airdrie",
        "crs": "ADR"
    },
    {
        "stationName": "Albany Park",
        "crs": "AYP"
    },
    {
        "stationName": "Albrighton",
        "crs": "ALB"
    },
    {
        "stationName": "Alderley Edge",
        "crs": "ALD"
    },
    {
        "stationName": "Aldermaston",
        "crs": "AMT"
    },
    {
        "stationName": "Aldershot",
        "crs": "AHT"
    },
    {
        "stationName": "Aldrington",
        "crs": "AGT"
    },
    {
        "stationName": "Alexandra Palace",
        "crs": "AAP"
    },
    {
        "stationName": "Alexandra Parade",
        "crs": "AXP"
    },
    {
        "stationName": "Alexandria",
        "crs": "ALX"
    },
    {
        "stationName": "Alfreton",
        "crs": "ALF"
    },
    {
        "stationName": "Allens West",
        "crs": "ALW"
    },
    {
        "stationName": "Alloa",
        "crs": "ALO"
    },
    {
        "stationName": "Alness",
        "crs": "ASS"
    },
    {
        "stationName": "Alnmouth",
        "crs": "ALM"
    },
    {
        "stationName": "Alresford (Essex)",
        "crs": "ALR"
    },
    {
        "stationName": "Alsager",
        "crs": "ASG"
    },
    {
        "stationName": "Althorne (Essex)",
        "crs": "ALN"
    },
    {
        "stationName": "Althorpe",
        "crs": "ALP"
    },
    {
        "stationName": "Altnabreac",
        "crs": "ABC"
    },
    {
        "stationName": "Alton",
        "crs": "AON"
    },
    {
        "stationName": "Altrincham",
        "crs": "ALT"
    },
    {
        "stationName": "Alvechurch",
        "crs": "ALV"
    },
    {
        "stationName": "Ambergate",
        "crs": "AMB"
    },
    {
        "stationName": "Amberley",
        "crs": "AMY"
    },
    {
        "stationName": "Amersham",
        "crs": "AMR"
    },
    {
        "stationName": "Ammanford",
        "crs": "AMF"
    },
    {
        "stationName": "Ancaster",
        "crs": "ANC"
    },
    {
        "stationName": "Anderston",
        "crs": "AND"
    },
    {
        "stationName": "Andover",
        "crs": "ADV"
    },
    {
        "stationName": "Anerley",
        "crs": "ANZ"
    },
    {
        "stationName": "Angmering",
        "crs": "ANG"
    },
    {
        "stationName": "Annan",
        "crs": "ANN"
    },
    {
        "stationName": "Anniesland",
        "crs": "ANL"
    },
    {
        "stationName": "Ansdell & Fairhaven",
        "crs": "AFV"
    },
    {
        "stationName": "Apperley Bridge",
        "crs": "APY"
    },
    {
        "stationName": "Appleby",
        "crs": "APP"
    },
    {
        "stationName": "Appledore (Kent)",
        "crs": "APD"
    },
    {
        "stationName": "Appleford",
        "crs": "APF"
    },
    {
        "stationName": "Appley Bridge",
        "crs": "APB"
    },
    {
        "stationName": "Apsley",
        "crs": "APS"
    },
    {
        "stationName": "Arbroath",
        "crs": "ARB"
    },
    {
        "stationName": "Ardgay",
        "crs": "ARD"
    },
    {
        "stationName": "Ardlui",
        "crs": "AUI"
    },
    {
        "stationName": "Ardrossan Harbour",
        "crs": "ADS"
    },
    {
        "stationName": "Ardrossan South Beach",
        "crs": "ASB"
    },
    {
        "stationName": "Ardrossan Town",
        "crs": "ADN"
    },
    {
        "stationName": "Ardwick",
        "crs": "ADK"
    },
    {
        "stationName": "Argyle Street",
        "crs": "AGS"
    },
    {
        "stationName": "Arisaig",
        "crs": "ARG"
    },
    {
        "stationName": "Arlesey",
        "crs": "ARL"
    },
    {
        "stationName": "Armadale (West Lothian)",
        "crs": "ARM"
    },
    {
        "stationName": "Armathwaite",
        "crs": "AWT"
    },
    {
        "stationName": "Arnside",
        "crs": "ARN"
    },
    {
        "stationName": "Arram",
        "crs": "ARR"
    },
    {
        "stationName": "Arrochar & Tarbet",
        "crs": "ART"
    },
    {
        "stationName": "Arundel",
        "crs": "ARU"
    },
    {
        "stationName": "Ascot (Berks)",
        "crs": "ACT"
    },
    {
        "stationName": "Ascott-under-Wychwood",
        "crs": "AUW"
    },
    {
        "stationName": "Ash",
        "crs": "ASH"
    },
    {
        "stationName": "Ash Vale",
        "crs": "AHV"
    },
    {
        "stationName": "Ashburys",
        "crs": "ABY"
    },
    {
        "stationName": "Ashchurch for Tewkesbury",
        "crs": "ASC"
    },
    {
        "stationName": "Ashfield",
        "crs": "ASF"
    },
    {
        "stationName": "Ashford (Surrey)",
        "crs": "AFS"
    },
    {
        "stationName": "Ashford International",
        "crs": "AFK"
    },
    {
        "stationName": "Ashford International (Eurostar)",
        "crs": "ASI"
    },
    {
        "stationName": "Ashley",
        "crs": "ASY"
    },
    {
        "stationName": "Ashtead",
        "crs": "AHD"
    },
    {
        "stationName": "Ashton-under-Lyne",
        "crs": "AHN"
    },
    {
        "stationName": "Ashurst (Kent)",
        "crs": "AHS"
    },
    {
        "stationName": "Ashurst New Forest",
        "crs": "ANF"
    },
    {
        "stationName": "Ashwell & Morden",
        "crs": "AWM"
    },
    {
        "stationName": "Askam",
        "crs": "ASK"
    },
    {
        "stationName": "Aslockton",
        "crs": "ALK"
    },
    {
        "stationName": "Aspatria",
        "crs": "ASP"
    },
    {
        "stationName": "Aspley Guise",
        "crs": "APG"
    },
    {
        "stationName": "Aston",
        "crs": "AST"
    },
    {
        "stationName": "Atherstone",
        "crs": "ATH"
    },
    {
        "stationName": "Atherton",
        "crs": "ATN"
    },
    {
        "stationName": "Attadale",
        "crs": "ATT"
    },
    {
        "stationName": "Attenborough",
        "crs": "ATB"
    },
    {
        "stationName": "Attleborough",
        "crs": "ATL"
    },
    {
        "stationName": "Auchinleck",
        "crs": "AUK"
    },
    {
        "stationName": "Audley End",
        "crs": "AUD"
    },
    {
        "stationName": "Aughton Park",
        "crs": "AUG"
    },
    {
        "stationName": "Aviemore",
        "crs": "AVM"
    },
    {
        "stationName": "Avoncliff",
        "crs": "AVF"
    },
    {
        "stationName": "Avonmouth",
        "crs": "AVN"
    },
    {
        "stationName": "Axminster",
        "crs": "AXM"
    },
    {
        "stationName": "Aylesbury",
        "crs": "AYS"
    },
    {
        "stationName": "Aylesbury Vale Parkway",
        "crs": "AVP"
    },
    {
        "stationName": "Aylesford",
        "crs": "AYL"
    },
    {
        "stationName": "Aylesham",
        "crs": "AYH"
    },
    {
        "stationName": "Ayr",
        "crs": "AYR"
    },
    {
        "stationName": "Bache",
        "crs": "BAC"
    },
    {
        "stationName": "Baglan",
        "crs": "BAJ"
    },
    {
        "stationName": "Bagshot",
        "crs": "BAG"
    },
    {
        "stationName": "Baildon",
        "crs": "BLD"
    },
    {
        "stationName": "Baillieston",
        "crs": "BIO"
    },
    {
        "stationName": "Balcombe",
        "crs": "BAB"
    },
    {
        "stationName": "Baldock",
        "crs": "BDK"
    },
    {
        "stationName": "Balham",
        "crs": "BAL"
    },
    {
        "stationName": "Balloch",
        "crs": "BHC"
    },
    {
        "stationName": "Balmossie",
        "crs": "BSI"
    },
    {
        "stationName": "Bamber Bridge",
        "crs": "BMB"
    },
    {
        "stationName": "Bamford",
        "crs": "BAM"
    },
    {
        "stationName": "Banavie",
        "crs": "BNV"
    },
    {
        "stationName": "Banbury",
        "crs": "BAN"
    },
    {
        "stationName": "Bangor (Gwynedd)",
        "crs": "BNG"
    },
    {
        "stationName": "Bank Hall",
        "crs": "BAH"
    },
    {
        "stationName": "Banstead",
        "crs": "BAD"
    },
    {
        "stationName": "Barassie",
        "crs": "BSS"
    },
    {
        "stationName": "Barbican",
        "crs": "ZBB"
    },
    {
        "stationName": "Bardon Mill",
        "crs": "BLL"
    },
    {
        "stationName": "Bare Lane",
        "crs": "BAR"
    },
    {
        "stationName": "Bargeddie",
        "crs": "BGI"
    },
    {
        "stationName": "Bargoed",
        "crs": "BGD"
    },
    {
        "stationName": "Barking",
        "crs": "BKG"
    },
    {
        "stationName": "Barlaston",
        "crs": "BRT"
    },
    {
        "stationName": "Barming",
        "crs": "BMG"
    },
    {
        "stationName": "Barmouth",
        "crs": "BRM"
    },
    {
        "stationName": "Barnehurst",
        "crs": "BNH"
    },
    {
        "stationName": "Barnes",
        "crs": "BNS"
    },
    {
        "stationName": "Barnes Bridge",
        "crs": "BNI"
    },
    {
        "stationName": "Barnetby",
        "crs": "BTB"
    },
    {
        "stationName": "Barnham",
        "crs": "BAA"
    },
    {
        "stationName": "Barnhill",
        "crs": "BNL"
    },
    {
        "stationName": "Barnsley",
        "crs": "BNY"
    },
    {
        "stationName": "Barnstaple",
        "crs": "BNP"
    },
    {
        "stationName": "Barnt Green",
        "crs": "BTG"
    },
    {
        "stationName": "Barrhead",
        "crs": "BRR"
    },
    {
        "stationName": "Barrhill",
        "crs": "BRL"
    },
    {
        "stationName": "Barrow Haven",
        "crs": "BAV"
    },
    {
        "stationName": "Barrow-in-Furness",
        "crs": "BIF"
    },
    {
        "stationName": "Barrow-Upon-Soar",
        "crs": "BWS"
    },
    {
        "stationName": "Barry",
        "crs": "BRY"
    },
    {
        "stationName": "Barry Docks",
        "crs": "BYD"
    },
    {
        "stationName": "Barry Island",
        "crs": "BYI"
    },
    {
        "stationName": "Barry Links",
        "crs": "BYL"
    },
    {
        "stationName": "Barton-on-Humber",
        "crs": "BAU"
    },
    {
        "stationName": "Basildon",
        "crs": "BSO"
    },
    {
        "stationName": "Basingstoke",
        "crs": "BSK"
    },
    {
        "stationName": "Bat & Ball",
        "crs": "BBL"
    },
    {
        "stationName": "Bath Spa",
        "crs": "BTH"
    },
    {
        "stationName": "Bathgate",
        "crs": "BHG"
    },
    {
        "stationName": "Batley",
        "crs": "BTL"
    },
    {
        "stationName": "Battersby",
        "crs": "BTT"
    },
    {
        "stationName": "Battersea Park",
        "crs": "BAK"
    },
    {
        "stationName": "Battle",
        "crs": "BAT"
    },
    {
        "stationName": "Battlesbridge",
        "crs": "BLB"
    },
    {
        "stationName": "Bayford",
        "crs": "BAY"
    },
    {
        "stationName": "Beaconsfield",
        "crs": "BCF"
    },
    {
        "stationName": "Bearley",
        "crs": "BER"
    },
    {
        "stationName": "Bearsden",
        "crs": "BRN"
    },
    {
        "stationName": "Bearsted",
        "crs": "BSD"
    },
    {
        "stationName": "Beasdale",
        "crs": "BSL"
    },
    {
        "stationName": "Beaulieu Road",
        "crs": "BEU"
    },
    {
        "stationName": "Beauly",
        "crs": "BEL"
    },
    {
        "stationName": "Bebington",
        "crs": "BEB"
    },
    {
        "stationName": "Beccles",
        "crs": "BCC"
    },
    {
        "stationName": "Beckenham Hill",
        "crs": "BEC"
    },
    {
        "stationName": "Beckenham Junction",
        "crs": "BKJ"
    },
    {
        "stationName": "Bedford",
        "crs": "BDM"
    },
    {
        "stationName": "Bedford St Johns",
        "crs": "BSJ"
    },
    {
        "stationName": "Bedhampton",
        "crs": "BDH"
    },
    {
        "stationName": "Bedminster",
        "crs": "BMT"
    },
    {
        "stationName": "Bedworth",
        "crs": "BEH"
    },
    {
        "stationName": "Bedwyn",
        "crs": "BDW"
    },
    {
        "stationName": "Beeston",
        "crs": "BEE"
    },
    {
        "stationName": "Bekesbourne",
        "crs": "BKS"
    },
    {
        "stationName": "Belle Vue",
        "crs": "BLV"
    },
    {
        "stationName": "Bellgrove",
        "crs": "BLG"
    },
    {
        "stationName": "Bellingham",
        "crs": "BGM"
    },
    {
        "stationName": "Bellshill",
        "crs": "BLH"
    },
    {
        "stationName": "Belmont",
        "crs": "BLM"
    },
    {
        "stationName": "Belper",
        "crs": "BLP"
    },
    {
        "stationName": "Beltring",
        "crs": "BEG"
    },
    {
        "stationName": "Belvedere",
        "crs": "BVD"
    },
    {
        "stationName": "Bempton",
        "crs": "BEM"
    },
    {
        "stationName": "Ben Rhydding",
        "crs": "BEY"
    },
    {
        "stationName": "Benfleet",
        "crs": "BEF"
    },
    {
        "stationName": "Bentham",
        "crs": "BEN"
    },
    {
        "stationName": "Bentley (Hants)",
        "crs": "BTY"
    },
    {
        "stationName": "Bentley (South Yorks)",
        "crs": "BYK"
    },
    {
        "stationName": "Bere Alston",
        "crs": "BAS"
    },
    {
        "stationName": "Bere Ferrers",
        "crs": "BFE"
    },
    {
        "stationName": "Berkhamsted",
        "crs": "BKM"
    },
    {
        "stationName": "Berkswell",
        "crs": "BKW"
    },
    {
        "stationName": "Bermuda Park",
        "crs": "BEP"
    },
    {
        "stationName": "Berney Arms",
        "crs": "BYA"
    },
    {
        "stationName": "Berry Brow",
        "crs": "BBW"
    },
    {
        "stationName": "Berrylands",
        "crs": "BRS"
    },
    {
        "stationName": "Berwick (Sussex)",
        "crs": "BRK"
    },
    {
        "stationName": "Berwick-upon-Tweed",
        "crs": "BWK"
    },
    {
        "stationName": "Bescar Lane",
        "crs": "BES"
    },
    {
        "stationName": "Bescot Stadium",
        "crs": "BSC"
    },
    {
        "stationName": "Betchworth",
        "crs": "BTO"
    },
    {
        "stationName": "Bethnal Green",
        "crs": "BET"
    },
    {
        "stationName": "Betws-y-Coed",
        "crs": "BYC"
    },
    {
        "stationName": "Beverley",
        "crs": "BEV"
    },
    {
        "stationName": "Bexhill",
        "crs": "BEX"
    },
    {
        "stationName": "Bexley",
        "crs": "BXY"
    },
    {
        "stationName": "Bexleyheath",
        "crs": "BXH"
    },
    {
        "stationName": "Bicester North",
        "crs": "BCS"
    },
    {
        "stationName": "Bicester Village",
        "crs": "BIT"
    },
    {
        "stationName": "Bickley",
        "crs": "BKL"
    },
    {
        "stationName": "Bidston",
        "crs": "BID"
    },
    {
        "stationName": "Biggleswade",
        "crs": "BIW"
    },
    {
        "stationName": "Bilbrook",
        "crs": "BBK"
    },
    {
        "stationName": "Billericay",
        "crs": "BIC"
    },
    {
        "stationName": "Billingham (Cleveland)",
        "crs": "BIL"
    },
    {
        "stationName": "Billingshurst",
        "crs": "BIG"
    },
    {
        "stationName": "Bingham",
        "crs": "BIN"
    },
    {
        "stationName": "Bingley",
        "crs": "BIY"
    },
    {
        "stationName": "Birchgrove",
        "crs": "BCG"
    },
    {
        "stationName": "Birchington-on-sea",
        "crs": "BCH"
    },
    {
        "stationName": "Birchwood",
        "crs": "BWD"
    },
    {
        "stationName": "Birkbeck",
        "crs": "BIK"
    },
    {
        "stationName": "Birkdale",
        "crs": "BDL"
    },
    {
        "stationName": "Birkenhead Central",
        "crs": "BKC"
    },
    {
        "stationName": "Birkenhead Hamilton Square",
        "crs": "BKQ"
    },
    {
        "stationName": "Birkenhead North",
        "crs": "BKN"
    },
    {
        "stationName": "Birkenhead Park",
        "crs": "BKP"
    },
    {
        "stationName": "Birmingham International",
        "crs": "BHI"
    },
    {
        "stationName": "Birmingham Moor Street",
        "crs": "BMO"
    },
    {
        "stationName": "Birmingham New Street",
        "crs": "BHM"
    },
    {
        "stationName": "Birmingham Snow Hill",
        "crs": "BSW"
    },
    {
        "stationName": "Bishop Auckland",
        "crs": "BIA"
    },
    {
        "stationName": "Bishopbriggs",
        "crs": "BBG"
    },
    {
        "stationName": "Bishops Stortford",
        "crs": "BIS"
    },
    {
        "stationName": "Bishopstone (Sussex)",
        "crs": "BIP"
    },
    {
        "stationName": "Bishopton (Strathclyde)",
        "crs": "BPT"
    },
    {
        "stationName": "Bitterne",
        "crs": "BTE"
    },
    {
        "stationName": "Blackburn",
        "crs": "BBN"
    },
    {
        "stationName": "Blackheath",
        "crs": "BKH"
    },
    {
        "stationName": "Blackhorse Road",
        "crs": "BHO"
    },
    {
        "stationName": "Blackpool North",
        "crs": "BPN"
    },
    {
        "stationName": "Blackpool Pleasure Beach",
        "crs": "BPB"
    },
    {
        "stationName": "Blackpool South",
        "crs": "BPS"
    },
    {
        "stationName": "Blackridge",
        "crs": "BKR"
    },
    {
        "stationName": "Blackrod",
        "crs": "BLK"
    },
    {
        "stationName": "Blackwater",
        "crs": "BAW"
    },
    {
        "stationName": "Blaenau Ffestiniog",
        "crs": "BFF"
    },
    {
        "stationName": "Blair Atholl",
        "crs": "BLA"
    },
    {
        "stationName": "Blairhill",
        "crs": "BAI"
    },
    {
        "stationName": "Blake Street",
        "crs": "BKT"
    },
    {
        "stationName": "Blakedown",
        "crs": "BKD"
    },
    {
        "stationName": "Blantyre",
        "crs": "BLT"
    },
    {
        "stationName": "Blaydon",
        "crs": "BLO"
    },
    {
        "stationName": "Bleasby",
        "crs": "BSB"
    },
    {
        "stationName": "Bletchley",
        "crs": "BLY"
    },
    {
        "stationName": "Bloxwich",
        "crs": "BLX"
    },
    {
        "stationName": "Bloxwich North",
        "crs": "BWN"
    },
    {
        "stationName": "Blundellsands & Crosby",
        "crs": "BLN"
    },
    {
        "stationName": "Blythe Bridge",
        "crs": "BYB"
    },
    {
        "stationName": "Bodmin Parkway",
        "crs": "BOD"
    },
    {
        "stationName": "Bodorgan",
        "crs": "BOR"
    },
    {
        "stationName": "Bognor Regis",
        "crs": "BOG"
    },
    {
        "stationName": "Bogston",
        "crs": "BGS"
    },
    {
        "stationName": "Bolton",
        "crs": "BON"
    },
    {
        "stationName": "Bolton-Upon-Dearne",
        "crs": "BTD"
    },
    {
        "stationName": "Bookham",
        "crs": "BKA"
    },
    {
        "stationName": "Bootle (Cumbria)",
        "crs": "BOC"
    },
    {
        "stationName": "Bootle New Strand",
        "crs": "BNW"
    },
    {
        "stationName": "Bootle Oriel Road",
        "crs": "BOT"
    },
    {
        "stationName": "Bordesley",
        "crs": "BBS"
    },
    {
        "stationName": "Borough Green & Wrotham",
        "crs": "BRG"
    },
    {
        "stationName": "Borth",
        "crs": "BRH"
    },
    {
        "stationName": "Bosham",
        "crs": "BOH"
    },
    {
        "stationName": "Boston",
        "crs": "BSN"
    },
    {
        "stationName": "Botley",
        "crs": "BOE"
    },
    {
        "stationName": "Bottesford",
        "crs": "BTF"
    },
    {
        "stationName": "Bourne End",
        "crs": "BNE"
    },
    {
        "stationName": "Bournemouth",
        "crs": "BMH"
    },
    {
        "stationName": "Bournville",
        "crs": "BRV"
    },
    {
        "stationName": "Bow Brickhill",
        "crs": "BWB"
    },
    {
        "stationName": "Bowes Park",
        "crs": "BOP"
    },
    {
        "stationName": "Bowling",
        "crs": "BWG"
    },
    {
        "stationName": "Box Hill & Westhumble",
        "crs": "BXW"
    },
    {
        "stationName": "Bracknell",
        "crs": "BCE"
    },
    {
        "stationName": "Bradford Forster Square",
        "crs": "BDQ"
    },
    {
        "stationName": "Bradford Interchange",
        "crs": "BDI"
    },
    {
        "stationName": "Bradford-on-Avon",
        "crs": "BOA"
    },
    {
        "stationName": "Brading",
        "crs": "BDN"
    },
    {
        "stationName": "Braintree",
        "crs": "BTR"
    },
    {
        "stationName": "Braintree Freeport",
        "crs": "BTP"
    },
    {
        "stationName": "Bramhall",
        "crs": "BML"
    },
    {
        "stationName": "Bramley (Hants)",
        "crs": "BMY"
    },
    {
        "stationName": "Bramley (W Yorks)",
        "crs": "BLE"
    },
    {
        "stationName": "Brampton (Cumbria)",
        "crs": "BMP"
    },
    {
        "stationName": "Brampton (Suffolk)",
        "crs": "BRP"
    },
    {
        "stationName": "Branchton",
        "crs": "BCN"
    },
    {
        "stationName": "Brandon",
        "crs": "BND"
    },
    {
        "stationName": "Branksome",
        "crs": "BSM"
    },
    {
        "stationName": "Braystones (Cumbria)",
        "crs": "BYS"
    },
    {
        "stationName": "Bredbury",
        "crs": "BDY"
    },
    {
        "stationName": "Breich",
        "crs": "BRC"
    },
    {
        "stationName": "Brentford",
        "crs": "BFD"
    },
    {
        "stationName": "Brentwood",
        "crs": "BRE"
    },
    {
        "stationName": "Bricket Wood",
        "crs": "BWO"
    },
    {
        "stationName": "Bridge of Allan",
        "crs": "BEA"
    },
    {
        "stationName": "Bridge of Orchy",
        "crs": "BRO"
    },
    {
        "stationName": "Bridgend",
        "crs": "BGN"
    },
    {
        "stationName": "Bridgeton",
        "crs": "BDG"
    },
    {
        "stationName": "Bridgwater",
        "crs": "BWT"
    },
    {
        "stationName": "Bridlington",
        "crs": "BDT"
    },
    {
        "stationName": "Brierfield",
        "crs": "BRF"
    },
    {
        "stationName": "Brigg",
        "crs": "BGG"
    },
    {
        "stationName": "Brighouse",
        "crs": "BGH"
    },
    {
        "stationName": "Brighton (East Sussex)",
        "crs": "BTN"
    },
    {
        "stationName": "Brimsdown",
        "crs": "BMD"
    },
    {
        "stationName": "Brinnington",
        "crs": "BNT"
    },
    {
        "stationName": "Bristol Parkway",
        "crs": "BPW"
    },
    {
        "stationName": "Bristol Temple Meads",
        "crs": "BRI"
    },
    {
        "stationName": "Brithdir",
        "crs": "BHD"
    },
    {
        "stationName": "Briton Ferry",
        "crs": "BNF"
    },
    {
        "stationName": "Brixton",
        "crs": "BRX"
    },
    {
        "stationName": "Broad Green",
        "crs": "BGE"
    },
    {
        "stationName": "Broadbottom",
        "crs": "BDB"
    },
    {
        "stationName": "Broadstairs",
        "crs": "BSR"
    },
    {
        "stationName": "Brockenhurst",
        "crs": "BCU"
    },
    {
        "stationName": "Brockholes",
        "crs": "BHS"
    },
    {
        "stationName": "Brockley",
        "crs": "BCY"
    },
    {
        "stationName": "Bromborough",
        "crs": "BOM"
    },
    {
        "stationName": "Bromborough Rake",
        "crs": "BMR"
    },
    {
        "stationName": "Bromley Cross (Lancs)",
        "crs": "BMC"
    },
    {
        "stationName": "Bromley North",
        "crs": "BMN"
    },
    {
        "stationName": "Bromley South",
        "crs": "BMS"
    },
    {
        "stationName": "Bromsgrove",
        "crs": "BMV"
    },
    {
        "stationName": "Brondesbury",
        "crs": "BSY"
    },
    {
        "stationName": "Brondesbury Park",
        "crs": "BSP"
    },
    {
        "stationName": "Brookmans Park",
        "crs": "BPK"
    },
    {
        "stationName": "Brookwood",
        "crs": "BKO"
    },
    {
        "stationName": "Broome",
        "crs": "BME"
    },
    {
        "stationName": "Broomfleet",
        "crs": "BMF"
    },
    {
        "stationName": "Brora",
        "crs": "BRA"
    },
    {
        "stationName": "Brough",
        "crs": "BUH"
    },
    {
        "stationName": "Broughty Ferry",
        "crs": "BYF"
    },
    {
        "stationName": "Broxbourne",
        "crs": "BXB"
    },
    {
        "stationName": "Bruce Grove",
        "crs": "BCV"
    },
    {
        "stationName": "Brundall",
        "crs": "BDA"
    },
    {
        "stationName": "Brundall Gardens",
        "crs": "BGA"
    },
    {
        "stationName": "Brunstane",
        "crs": "BSU"
    },
    {
        "stationName": "Brunswick",
        "crs": "BRW"
    },
    {
        "stationName": "Bruton",
        "crs": "BRU"
    },
    {
        "stationName": "Bryn",
        "crs": "BYN"
    },
    {
        "stationName": "Buckenham (Norfolk)",
        "crs": "BUC"
    },
    {
        "stationName": "Buckley",
        "crs": "BCK"
    },
    {
        "stationName": "Bucknell",
        "crs": "BUK"
    },
    {
        "stationName": "Buckshaw Parkway",
        "crs": "BSV"
    },
    {
        "stationName": "Bugle",
        "crs": "BGL"
    },
    {
        "stationName": "Builth Road",
        "crs": "BHR"
    },
    {
        "stationName": "Bulwell",
        "crs": "BLW"
    },
    {
        "stationName": "Bures",
        "crs": "BUE"
    },
    {
        "stationName": "Burgess Hill",
        "crs": "BUG"
    },
    {
        "stationName": "Burley Park",
        "crs": "BUY"
    },
    {
        "stationName": "Burley-in-Wharfedale",
        "crs": "BUW"
    },
    {
        "stationName": "Burnage",
        "crs": "BNA"
    },
    {
        "stationName": "Burneside (Cumbria)",
        "crs": "BUD"
    },
    {
        "stationName": "Burnham (Bucks)",
        "crs": "BNM"
    },
    {
        "stationName": "Burnham-on-Crouch",
        "crs": "BUU"
    },
    {
        "stationName": "Burnley Barracks",
        "crs": "BUB"
    },
    {
        "stationName": "Burnley Central",
        "crs": "BNC"
    },
    {
        "stationName": "Burnley Manchester Road",
        "crs": "BYM"
    },
    {
        "stationName": "Burnside (Strathclyde)",
        "crs": "BUI"
    },
    {
        "stationName": "Burntisland",
        "crs": "BTS"
    },
    {
        "stationName": "Burscough Bridge",
        "crs": "BCB"
    },
    {
        "stationName": "Burscough Junction",
        "crs": "BCJ"
    },
    {
        "stationName": "Bursledon",
        "crs": "BUO"
    },
    {
        "stationName": "Burton Joyce",
        "crs": "BUJ"
    },
    {
        "stationName": "Burton-on-Trent",
        "crs": "BUT"
    },
    {
        "stationName": "Bury St Edmunds",
        "crs": "BSE"
    },
    {
        "stationName": "Busby",
        "crs": "BUS"
    },
    {
        "stationName": "Bush Hill Park",
        "crs": "BHK"
    },
    {
        "stationName": "Bushey",
        "crs": "BSH"
    },
    {
        "stationName": "Butlers Lane",
        "crs": "BUL"
    },
    {
        "stationName": "Buxted",
        "crs": "BXD"
    },
    {
        "stationName": "Buxton",
        "crs": "BUX"
    },
    {
        "stationName": "Byfleet & New Haw",
        "crs": "BFN"
    },
    {
        "stationName": "Bynea",
        "crs": "BYE"
    },
    {
        "stationName": "Cadoxton",
        "crs": "CAD"
    },
    {
        "stationName": "Caergwrle",
        "crs": "CGW"
    },
    {
        "stationName": "Caerphilly",
        "crs": "CPH"
    },
    {
        "stationName": "Caersws",
        "crs": "CWS"
    },
    {
        "stationName": "Caldercruix",
        "crs": "CAC"
    },
    {
        "stationName": "Caldicot",
        "crs": "CDT"
    },
    {
        "stationName": "Caledonian Rd & Barnsbury",
        "crs": "CIR"
    },
    {
        "stationName": "Calstock",
        "crs": "CSK"
    },
    {
        "stationName": "Cam & Dursley",
        "crs": "CDU"
    },
    {
        "stationName": "Camberley",
        "crs": "CAM"
    },
    {
        "stationName": "Camborne",
        "crs": "CBN"
    },
    {
        "stationName": "Cambridge",
        "crs": "CBG"
    },
    {
        "stationName": "Cambridge Heath",
        "crs": "CBH"
    },
    {
        "stationName": "Cambridge North",
        "crs": "CMB"
    },
    {
        "stationName": "Cambuslang",
        "crs": "CBL"
    },
    {
        "stationName": "Camden Road",
        "crs": "CMD"
    },
    {
        "stationName": "Camelon",
        "crs": "CMO"
    },
    {
        "stationName": "Canada Water",
        "crs": "ZCW"
    },
    {
        "stationName": "Canley",
        "crs": "CNL"
    },
    {
        "stationName": "Cannock",
        "crs": "CAO"
    },
    {
        "stationName": "Canonbury",
        "crs": "CNN"
    },
    {
        "stationName": "Canterbury East",
        "crs": "CBE"
    },
    {
        "stationName": "Canterbury West",
        "crs": "CBW"
    },
    {
        "stationName": "Cantley",
        "crs": "CNY"
    },
    {
        "stationName": "Capenhurst",
        "crs": "CPU"
    },
    {
        "stationName": "Carbis Bay",
        "crs": "CBB"
    },
    {
        "stationName": "Cardenden",
        "crs": "CDD"
    },
    {
        "stationName": "Cardiff Bay",
        "crs": "CDB"
    },
    {
        "stationName": "Cardiff Central",
        "crs": "CDF"
    },
    {
        "stationName": "Cardiff Queen Street",
        "crs": "CDQ"
    },
    {
        "stationName": "Cardonald",
        "crs": "CDO"
    },
    {
        "stationName": "Cardross",
        "crs": "CDR"
    },
    {
        "stationName": "Carfin",
        "crs": "CRF"
    },
    {
        "stationName": "Cark & Cartmel",
        "crs": "CAK"
    },
    {
        "stationName": "Carlisle",
        "crs": "CAR"
    },
    {
        "stationName": "Carlton",
        "crs": "CTO"
    },
    {
        "stationName": "Carluke",
        "crs": "CLU"
    },
    {
        "stationName": "Carmarthen",
        "crs": "CMN"
    },
    {
        "stationName": "Carmyle",
        "crs": "CML"
    },
    {
        "stationName": "Carnforth",
        "crs": "CNF"
    },
    {
        "stationName": "Carnoustie",
        "crs": "CAN"
    },
    {
        "stationName": "Carntyne",
        "crs": "CAY"
    },
    {
        "stationName": "Carpenders Park",
        "crs": "CPK"
    },
    {
        "stationName": "Carrbridge",
        "crs": "CAG"
    },
    {
        "stationName": "Carshalton",
        "crs": "CSH"
    },
    {
        "stationName": "Carshalton Beeches",
        "crs": "CSB"
    },
    {
        "stationName": "Carstairs",
        "crs": "CRS"
    },
    {
        "stationName": "Cartsdyke",
        "crs": "CDY"
    },
    {
        "stationName": "Castle Bar Park",
        "crs": "CBP"
    },
    {
        "stationName": "Castle Cary",
        "crs": "CLC"
    },
    {
        "stationName": "Castleford",
        "crs": "CFD"
    },
    {
        "stationName": "Castleton (Manchester)",
        "crs": "CAS"
    },
    {
        "stationName": "Castleton Moor",
        "crs": "CSM"
    },
    {
        "stationName": "Caterham",
        "crs": "CAT"
    },
    {
        "stationName": "Catford",
        "crs": "CTF"
    },
    {
        "stationName": "Catford Bridge",
        "crs": "CFB"
    },
    {
        "stationName": "Cathays",
        "crs": "CYS"
    },
    {
        "stationName": "Cathcart",
        "crs": "CCT"
    },
    {
        "stationName": "Cattal",
        "crs": "CTL"
    },
    {
        "stationName": "Causeland",
        "crs": "CAU"
    },
    {
        "stationName": "Cefn-y-Bedd",
        "crs": "CYB"
    },
    {
        "stationName": "Chadwell Heath",
        "crs": "CTH"
    },
    {
        "stationName": "Chafford Hundred Lakeside",
        "crs": "CFH"
    },
    {
        "stationName": "Chalfont & Latimer",
        "crs": "CFO"
    },
    {
        "stationName": "Chalkwell",
        "crs": "CHW"
    },
    {
        "stationName": "Chandlers Ford",
        "crs": "CFR"
    },
    {
        "stationName": "Chapel-en-le-Frith",
        "crs": "CEF"
    },
    {
        "stationName": "Chapelton (Devon)",
        "crs": "CPN"
    },
    {
        "stationName": "Chapeltown (South Yorks)",
        "crs": "CLN"
    },
    {
        "stationName": "Chappel & Wakes Colne",
        "crs": "CWC"
    },
    {
        "stationName": "Charing (Kent)",
        "crs": "CHG"
    },
    {
        "stationName": "Charing Cross (Glasgow)",
        "crs": "CHC"
    },
    {
        "stationName": "Charlbury",
        "crs": "CBY"
    },
    {
        "stationName": "Charlton",
        "crs": "CTN"
    },
    {
        "stationName": "Chartham",
        "crs": "CRT"
    },
    {
        "stationName": "Chassen Road",
        "crs": "CSR"
    },
    {
        "stationName": "Chatelherault",
        "crs": "CTE"
    },
    {
        "stationName": "Chatham",
        "crs": "CTM"
    },
    {
        "stationName": "Chathill",
        "crs": "CHT"
    },
    {
        "stationName": "Cheadle Hulme",
        "crs": "CHU"
    },
    {
        "stationName": "Cheam",
        "crs": "CHE"
    },
    {
        "stationName": "Cheddington",
        "crs": "CED"
    },
    {
        "stationName": "Chelford (Cheshire)",
        "crs": "CEL"
    },
    {
        "stationName": "Chelmsford",
        "crs": "CHM"
    },
    {
        "stationName": "Chelsfield",
        "crs": "CLD"
    },
    {
        "stationName": "Cheltenham Spa",
        "crs": "CNM"
    },
    {
        "stationName": "Chepstow",
        "crs": "CPW"
    },
    {
        "stationName": "Cherry Tree",
        "crs": "CYT"
    },
    {
        "stationName": "Chertsey",
        "crs": "CHY"
    },
    {
        "stationName": "Cheshunt",
        "crs": "CHN"
    },
    {
        "stationName": "Chessington North",
        "crs": "CSN"
    },
    {
        "stationName": "Chessington South",
        "crs": "CSS"
    },
    {
        "stationName": "Chester",
        "crs": "CTR"
    },
    {
        "stationName": "Chester Road",
        "crs": "CRD"
    },
    {
        "stationName": "Chesterfield",
        "crs": "CHD"
    },
    {
        "stationName": "Chester-le-Street",
        "crs": "CLS"
    },
    {
        "stationName": "Chestfield & Swalecliffe",
        "crs": "CSW"
    },
    {
        "stationName": "Chetnole",
        "crs": "CNO"
    },
    {
        "stationName": "Chichester",
        "crs": "CCH"
    },
    {
        "stationName": "Chilham",
        "crs": "CIL"
    },
    {
        "stationName": "Chilworth",
        "crs": "CHL"
    },
    {
        "stationName": "Chingford",
        "crs": "CHI"
    },
    {
        "stationName": "Chinley",
        "crs": "CLY"
    },
    {
        "stationName": "Chippenham",
        "crs": "CPM"
    },
    {
        "stationName": "Chipstead",
        "crs": "CHP"
    },
    {
        "stationName": "Chirk",
        "crs": "CRK"
    },
    {
        "stationName": "Chislehurst",
        "crs": "CIT"
    },
    {
        "stationName": "Chiswick",
        "crs": "CHK"
    },
    {
        "stationName": "Cholsey",
        "crs": "CHO"
    },
    {
        "stationName": "Chorley",
        "crs": "CRL"
    },
    {
        "stationName": "Chorleywood",
        "crs": "CLW"
    },
    {
        "stationName": "Christchurch",
        "crs": "CHR"
    },
    {
        "stationName": "Christs Hospital",
        "crs": "CHH"
    },
    {
        "stationName": "Church & Oswaldtwistle",
        "crs": "CTW"
    },
    {
        "stationName": "Church Fenton",
        "crs": "CHF"
    },
    {
        "stationName": "Church Stretton",
        "crs": "CTT"
    },
    {
        "stationName": "Cilmeri",
        "crs": "CIM"
    },
    {
        "stationName": "City Thameslink",
        "crs": "CTK"
    },
    {
        "stationName": "Clacton-on-Sea",
        "crs": "CLT"
    },
    {
        "stationName": "Clandon",
        "crs": "CLA"
    },
    {
        "stationName": "Clapham (North Yorkshire)",
        "crs": "CPY"
    },
    {
        "stationName": "Clapham High Street",
        "crs": "CLP"
    },
    {
        "stationName": "Clapham Junction",
        "crs": "CLJ"
    },
    {
        "stationName": "Clapton",
        "crs": "CPT"
    },
    {
        "stationName": "Clarbeston Road",
        "crs": "CLR"
    },
    {
        "stationName": "Clarkston",
        "crs": "CKS"
    },
    {
        "stationName": "Claverdon",
        "crs": "CLV"
    },
    {
        "stationName": "Claygate",
        "crs": "CLG"
    },
    {
        "stationName": "Cleethorpes",
        "crs": "CLE"
    },
    {
        "stationName": "Cleland",
        "crs": "CEA"
    },
    {
        "stationName": "Clifton (Manchester)",
        "crs": "CLI"
    },
    {
        "stationName": "Clifton Down",
        "crs": "CFN"
    },
    {
        "stationName": "Clitheroe",
        "crs": "CLH"
    },
    {
        "stationName": "Clock House",
        "crs": "CLK"
    },
    {
        "stationName": "Clunderwen",
        "crs": "CUW"
    },
    {
        "stationName": "Clydebank",
        "crs": "CYK"
    },
    {
        "stationName": "Coatbridge Central",
        "crs": "CBC"
    },
    {
        "stationName": "Coatbridge Sunnyside",
        "crs": "CBS"
    },
    {
        "stationName": "Coatdyke",
        "crs": "COA"
    },
    {
        "stationName": "Cobham & Stoke d'Abernon",
        "crs": "CSD"
    },
    {
        "stationName": "Codsall",
        "crs": "CSL"
    },
    {
        "stationName": "Cogan",
        "crs": "CGN"
    },
    {
        "stationName": "Colchester",
        "crs": "COL"
    },
    {
        "stationName": "Colchester Town",
        "crs": "CET"
    },
    {
        "stationName": "Coleshill Parkway",
        "crs": "CEH"
    },
    {
        "stationName": "Collingham",
        "crs": "CLM"
    },
    {
        "stationName": "Collington",
        "crs": "CLL"
    },
    {
        "stationName": "Colne",
        "crs": "CNE"
    },
    {
        "stationName": "Colwall",
        "crs": "CWL"
    },
    {
        "stationName": "Colwyn Bay",
        "crs": "CWB"
    },
    {
        "stationName": "Combe (Oxon)",
        "crs": "CME"
    },
    {
        "stationName": "Commondale",
        "crs": "COM"
    },
    {
        "stationName": "Congleton",
        "crs": "CNG"
    },
    {
        "stationName": "Conisbrough",
        "crs": "CNS"
    },
    {
        "stationName": "Connel Ferry",
        "crs": "CON"
    },
    {
        "stationName": "Conon Bridge",
        "crs": "CBD"
    },
    {
        "stationName": "Cononley",
        "crs": "CEY"
    },
    {
        "stationName": "Conway Park",
        "crs": "CNP"
    },
    {
        "stationName": "Conwy",
        "crs": "CNW"
    },
    {
        "stationName": "Cooden Beach",
        "crs": "COB"
    },
    {
        "stationName": "Cookham",
        "crs": "COO"
    },
    {
        "stationName": "Cooksbridge",
        "crs": "CBR"
    },
    {
        "stationName": "Coombe Junction Halt",
        "crs": "COE"
    },
    {
        "stationName": "Copplestone",
        "crs": "COP"
    },
    {
        "stationName": "Corbridge",
        "crs": "CRB"
    },
    {
        "stationName": "Corby",
        "crs": "COR"
    },
    {
        "stationName": "Corfe Castle",
        "crs": "CFC"
    },
    {
        "stationName": "Corkerhill",
        "crs": "CKH"
    },
    {
        "stationName": "Corkickle",
        "crs": "CKL"
    },
    {
        "stationName": "Corpach",
        "crs": "CPA"
    },
    {
        "stationName": "Corrour",
        "crs": "CRR"
    },
    {
        "stationName": "Coryton",
        "crs": "COY"
    },
    {
        "stationName": "Coseley",
        "crs": "CSY"
    },
    {
        "stationName": "Cosford",
        "crs": "COS"
    },
    {
        "stationName": "Cosham",
        "crs": "CSA"
    },
    {
        "stationName": "Cottingham",
        "crs": "CGM"
    },
    {
        "stationName": "Cottingley",
        "crs": "COT"
    },
    {
        "stationName": "Coulsdon South",
        "crs": "CDS"
    },
    {
        "stationName": "Coulsdon Town",
        "crs": "CDN"
    },
    {
        "stationName": "Coventry",
        "crs": "COV"
    },
    {
        "stationName": "Coventry Arena",
        "crs": "CAA"
    },
    {
        "stationName": "Cowden (Kent)",
        "crs": "CWN"
    },
    {
        "stationName": "Cowdenbeath",
        "crs": "COW"
    },
    {
        "stationName": "Cradley Heath",
        "crs": "CRA"
    },
    {
        "stationName": "Craigendoran",
        "crs": "CGD"
    },
    {
        "stationName": "Cramlington",
        "crs": "CRM"
    },
    {
        "stationName": "Cranbrook (Devon)",
        "crs": "CBK"
    },
    {
        "stationName": "Craven Arms",
        "crs": "CRV"
    },
    {
        "stationName": "Crawley",
        "crs": "CRW"
    },
    {
        "stationName": "Crayford",
        "crs": "CRY"
    },
    {
        "stationName": "Crediton",
        "crs": "CDI"
    },
    {
        "stationName": "Cressing (Essex)",
        "crs": "CES"
    },
    {
        "stationName": "Cressington",
        "crs": "CSG"
    },
    {
        "stationName": "Creswell",
        "crs": "CWD"
    },
    {
        "stationName": "Crewe",
        "crs": "CRE"
    },
    {
        "stationName": "Crewkerne",
        "crs": "CKN"
    },
    {
        "stationName": "Crews Hill",
        "crs": "CWH"
    },
    {
        "stationName": "Crianlarich",
        "crs": "CNR"
    },
    {
        "stationName": "Criccieth",
        "crs": "CCC"
    },
    {
        "stationName": "Cricklewood",
        "crs": "CRI"
    },
    {
        "stationName": "Croftfoot",
        "crs": "CFF"
    },
    {
        "stationName": "Crofton Park",
        "crs": "CFT"
    },
    {
        "stationName": "Cromer",
        "crs": "CMR"
    },
    {
        "stationName": "Cromford",
        "crs": "CMF"
    },
    {
        "stationName": "Crookston",
        "crs": "CKT"
    },
    {
        "stationName": "Cross Gates",
        "crs": "CRG"
    },
    {
        "stationName": "Crossflatts",
        "crs": "CFL"
    },
    {
        "stationName": "Crosshill",
        "crs": "COI"
    },
    {
        "stationName": "Crosskeys",
        "crs": "CKY"
    },
    {
        "stationName": "Crossmyloof",
        "crs": "CMY"
    },
    {
        "stationName": "Croston",
        "crs": "CSO"
    },
    {
        "stationName": "Crouch Hill",
        "crs": "CRH"
    },
    {
        "stationName": "Crowborough",
        "crs": "COH"
    },
    {
        "stationName": "Crowhurst",
        "crs": "CWU"
    },
    {
        "stationName": "Crowle",
        "crs": "CWE"
    },
    {
        "stationName": "Crowthorne",
        "crs": "CRN"
    },
    {
        "stationName": "Croy",
        "crs": "CRO"
    },
    {
        "stationName": "Crystal Palace",
        "crs": "CYP"
    },
    {
        "stationName": "Cuddington",
        "crs": "CUD"
    },
    {
        "stationName": "Cuffley",
        "crs": "CUF"
    },
    {
        "stationName": "Culham",
        "crs": "CUM"
    },
    {
        "stationName": "Culrain",
        "crs": "CUA"
    },
    {
        "stationName": "Cumbernauld",
        "crs": "CUB"
    },
    {
        "stationName": "Cupar",
        "crs": "CUP"
    },
    {
        "stationName": "Curriehill",
        "crs": "CUH"
    },
    {
        "stationName": "Cuxton",
        "crs": "CUX"
    },
    {
        "stationName": "Cwmbach",
        "crs": "CMH"
    },
    {
        "stationName": "Cwmbran",
        "crs": "CWM"
    },
    {
        "stationName": "Cynghordy",
        "crs": "CYN"
    },
    {
        "stationName": "Dagenham Dock",
        "crs": "DDK"
    },
    {
        "stationName": "Daisy Hill",
        "crs": "DSY"
    },
    {
        "stationName": "Dalgety Bay",
        "crs": "DAG"
    },
    {
        "stationName": "Dalmally",
        "crs": "DAL"
    },
    {
        "stationName": "Dalmarnock",
        "crs": "DAK"
    },
    {
        "stationName": "Dalmeny",
        "crs": "DAM"
    },
    {
        "stationName": "Dalmuir",
        "crs": "DMR"
    },
    {
        "stationName": "Dalreoch",
        "crs": "DLR"
    },
    {
        "stationName": "Dalry",
        "crs": "DLY"
    },
    {
        "stationName": "Dalston (Cumbria)",
        "crs": "DLS"
    },
    {
        "stationName": "Dalston Junction",
        "crs": "DLJ"
    },
    {
        "stationName": "Dalston Kingsland",
        "crs": "DLK"
    },
    {
        "stationName": "Dalton (Cumbria)",
        "crs": "DLT"
    },
    {
        "stationName": "Dalwhinnie",
        "crs": "DLW"
    },
    {
        "stationName": "Danby",
        "crs": "DNY"
    },
    {
        "stationName": "Danescourt",
        "crs": "DCT"
    },
    {
        "stationName": "Danzey",
        "crs": "DZY"
    },
    {
        "stationName": "Darlington",
        "crs": "DAR"
    },
    {
        "stationName": "Darnall",
        "crs": "DAN"
    },
    {
        "stationName": "Darsham",
        "crs": "DSM"
    },
    {
        "stationName": "Dartford",
        "crs": "DFD"
    },
    {
        "stationName": "Darton",
        "crs": "DRT"
    },
    {
        "stationName": "Darwen",
        "crs": "DWN"
    },
    {
        "stationName": "Datchet",
        "crs": "DAT"
    },
    {
        "stationName": "Davenport",
        "crs": "DVN"
    },
    {
        "stationName": "Dawlish",
        "crs": "DWL"
    },
    {
        "stationName": "Dawlish Warren",
        "crs": "DWW"
    },
    {
        "stationName": "Deal",
        "crs": "DEA"
    },
    {
        "stationName": "Dean (Wilts)",
        "crs": "DEN"
    },
    {
        "stationName": "Deansgate",
        "crs": "DGT"
    },
    {
        "stationName": "Deganwy",
        "crs": "DGY"
    },
    {
        "stationName": "Deighton",
        "crs": "DHN"
    },
    {
        "stationName": "Delamere",
        "crs": "DLM"
    },
    {
        "stationName": "Denby Dale",
        "crs": "DBD"
    },
    {
        "stationName": "Denham",
        "crs": "DNM"
    },
    {
        "stationName": "Denham Golf Club",
        "crs": "DGC"
    },
    {
        "stationName": "Denmark Hill",
        "crs": "DMK"
    },
    {
        "stationName": "Dent",
        "crs": "DNT"
    },
    {
        "stationName": "Denton",
        "crs": "DTN"
    },
    {
        "stationName": "Deptford",
        "crs": "DEP"
    },
    {
        "stationName": "Derby",
        "crs": "DBY"
    },
    {
        "stationName": "Derby Road (Ipswich)",
        "crs": "DBR"
    },
    {
        "stationName": "Devonport (Devon)",
        "crs": "DPT"
    },
    {
        "stationName": "Devonport Dockyard",
        "crs": "DOC"
    },
    {
        "stationName": "Dewsbury",
        "crs": "DEW"
    },
    {
        "stationName": "Didcot Parkway",
        "crs": "DID"
    },
    {
        "stationName": "Digby & Sowton",
        "crs": "DIG"
    },
    {
        "stationName": "Dilton Marsh",
        "crs": "DMH"
    },
    {
        "stationName": "Dinas (Rhondda)",
        "crs": "DMG"
    },
    {
        "stationName": "Dinas Powys",
        "crs": "DNS"
    },
    {
        "stationName": "Dingle Road",
        "crs": "DGL"
    },
    {
        "stationName": "Dingwall",
        "crs": "DIN"
    },
    {
        "stationName": "Dinsdale",
        "crs": "DND"
    },
    {
        "stationName": "Dinting",
        "crs": "DTG"
    },
    {
        "stationName": "Disley",
        "crs": "DSL"
    },
    {
        "stationName": "Diss",
        "crs": "DIS"
    },
    {
        "stationName": "Dodworth",
        "crs": "DOD"
    },
    {
        "stationName": "Dolau",
        "crs": "DOL"
    },
    {
        "stationName": "Doleham",
        "crs": "DLH"
    },
    {
        "stationName": "Dolgarrog",
        "crs": "DLG"
    },
    {
        "stationName": "Dolwyddelan",
        "crs": "DWD"
    },
    {
        "stationName": "Doncaster",
        "crs": "DON"
    },
    {
        "stationName": "Dorchester South",
        "crs": "DCH"
    },
    {
        "stationName": "Dorchester West",
        "crs": "DCW"
    },
    {
        "stationName": "Dore & Totley",
        "crs": "DOR"
    },
    {
        "stationName": "Dorking (Main)",
        "crs": "DKG"
    },
    {
        "stationName": "Dorking Deepdene",
        "crs": "DPD"
    },
    {
        "stationName": "Dorking West",
        "crs": "DKT"
    },
    {
        "stationName": "Dormans",
        "crs": "DMS"
    },
    {
        "stationName": "Dorridge",
        "crs": "DDG"
    },
    {
        "stationName": "Dove Holes",
        "crs": "DVH"
    },
    {
        "stationName": "Dover Priory",
        "crs": "DVP"
    },
    {
        "stationName": "Dovercourt",
        "crs": "DVC"
    },
    {
        "stationName": "Dovey Junction",
        "crs": "DVY"
    },
    {
        "stationName": "Downham Market",
        "crs": "DOW"
    },
    {
        "stationName": "Drayton Green",
        "crs": "DRG"
    },
    {
        "stationName": "Drayton Park",
        "crs": "DYP"
    },
    {
        "stationName": "Drem",
        "crs": "DRM"
    },
    {
        "stationName": "Driffield",
        "crs": "DRF"
    },
    {
        "stationName": "Drigg",
        "crs": "DRI"
    },
    {
        "stationName": "Droitwich Spa",
        "crs": "DTW"
    },
    {
        "stationName": "Dronfield",
        "crs": "DRO"
    },
    {
        "stationName": "Drumchapel",
        "crs": "DMC"
    },
    {
        "stationName": "Drumfrochar",
        "crs": "DFR"
    },
    {
        "stationName": "Drumgelloch",
        "crs": "DRU"
    },
    {
        "stationName": "Drumry",
        "crs": "DMY"
    },
    {
        "stationName": "Dublin Ferryport",
        "crs": "DFP"
    },
    {
        "stationName": "Dublin Port - Stena",
        "crs": "DPS"
    },
    {
        "stationName": "Duddeston",
        "crs": "DUD"
    },
    {
        "stationName": "Dudley Port",
        "crs": "DDP"
    },
    {
        "stationName": "Duffield",
        "crs": "DFI"
    },
    {
        "stationName": "Duirinish",
        "crs": "DRN"
    },
    {
        "stationName": "Duke Street",
        "crs": "DST"
    },
    {
        "stationName": "Dullingham",
        "crs": "DUL"
    },
    {
        "stationName": "Dumbarton Central",
        "crs": "DBC"
    },
    {
        "stationName": "Dumbarton East",
        "crs": "DBE"
    },
    {
        "stationName": "Dumbreck",
        "crs": "DUM"
    },
    {
        "stationName": "Dumfries",
        "crs": "DMF"
    },
    {
        "stationName": "Dumpton Park",
        "crs": "DMP"
    },
    {
        "stationName": "Dunbar",
        "crs": "DUN"
    },
    {
        "stationName": "Dunblane",
        "crs": "DBL"
    },
    {
        "stationName": "Duncraig",
        "crs": "DCG"
    },
    {
        "stationName": "Dundee",
        "crs": "DEE"
    },
    {
        "stationName": "Dunfermline Queen Margaret",
        "crs": "DFL"
    },
    {
        "stationName": "Dunfermline Town",
        "crs": "DFE"
    },
    {
        "stationName": "Dunkeld & Birnam",
        "crs": "DKD"
    },
    {
        "stationName": "Dunlop",
        "crs": "DNL"
    },
    {
        "stationName": "Dunrobin Castle",
        "crs": "DNO"
    },
    {
        "stationName": "Dunston",
        "crs": "DOT"
    },
    {
        "stationName": "Dunton Green",
        "crs": "DNG"
    },
    {
        "stationName": "Durham",
        "crs": "DHM"
    },
    {
        "stationName": "Durrington-on-Sea",
        "crs": "DUR"
    },
    {
        "stationName": "Dyce",
        "crs": "DYC"
    },
    {
        "stationName": "Dyffryn Ardudwy",
        "crs": "DYF"
    },
    {
        "stationName": "Eaglescliffe",
        "crs": "EAG"
    },
    {
        "stationName": "Ealing Broadway",
        "crs": "EAL"
    },
    {
        "stationName": "Earlestown",
        "crs": "ERL"
    },
    {
        "stationName": "Earley",
        "crs": "EAR"
    },
    {
        "stationName": "Earlsfield",
        "crs": "EAD"
    },
    {
        "stationName": "Earlswood (Surrey)",
        "crs": "ELD"
    },
    {
        "stationName": "Earlswood (West Midlands)",
        "crs": "EWD"
    },
    {
        "stationName": "East Croydon",
        "crs": "ECR"
    },
    {
        "stationName": "East Didsbury",
        "crs": "EDY"
    },
    {
        "stationName": "East Dulwich",
        "crs": "EDW"
    },
    {
        "stationName": "East Farleigh",
        "crs": "EFL"
    },
    {
        "stationName": "East Garforth",
        "crs": "EGF"
    },
    {
        "stationName": "East Grinstead",
        "crs": "EGR"
    },
    {
        "stationName": "East Kilbride",
        "crs": "EKL"
    },
    {
        "stationName": "East Malling",
        "crs": "EML"
    },
    {
        "stationName": "East Midlands Parkway",
        "crs": "EMD"
    },
    {
        "stationName": "East Tilbury",
        "crs": "ETL"
    },
    {
        "stationName": "East Worthing",
        "crs": "EWR"
    },
    {
        "stationName": "Eastbourne",
        "crs": "EBN"
    },
    {
        "stationName": "Eastbrook",
        "crs": "EBK"
    },
    {
        "stationName": "Easterhouse",
        "crs": "EST"
    },
    {
        "stationName": "Eastham Rake",
        "crs": "ERA"
    },
    {
        "stationName": "Eastleigh",
        "crs": "ESL"
    },
    {
        "stationName": "Eastrington",
        "crs": "EGN"
    },
    {
        "stationName": "Ebbsfleet International",
        "crs": "EBD"
    },
    {
        "stationName": "Ebbw Vale Parkway",
        "crs": "EBV"
    },
    {
        "stationName": "Ebbw Vale Town",
        "crs": "EBB"
    },
    {
        "stationName": "Eccles (Manchester)",
        "crs": "ECC"
    },
    {
        "stationName": "Eccles Road",
        "crs": "ECS"
    },
    {
        "stationName": "Eccleston Park",
        "crs": "ECL"
    },
    {
        "stationName": "Edale",
        "crs": "EDL"
    },
    {
        "stationName": "Eden Park",
        "crs": "EDN"
    },
    {
        "stationName": "Edenbridge",
        "crs": "EBR"
    },
    {
        "stationName": "Edenbridge Town",
        "crs": "EBT"
    },
    {
        "stationName": "Edge Hill",
        "crs": "EDG"
    },
    {
        "stationName": "Edinburgh",
        "crs": "EDB"
    },
    {
        "stationName": "Edinburgh Gateway",
        "crs": "EGY"
    },
    {
        "stationName": "Edinburgh Park",
        "crs": "EDP"
    },
    {
        "stationName": "Edmonton Green",
        "crs": "EDR"
    },
    {
        "stationName": "Effingham Junction",
        "crs": "EFF"
    },
    {
        "stationName": "Eggesford",
        "crs": "EGG"
    },
    {
        "stationName": "Egham",
        "crs": "EGH"
    },
    {
        "stationName": "Egton",
        "crs": "EGT"
    },
    {
        "stationName": "Elephant & Castle",
        "crs": "EPH"
    },
    {
        "stationName": "Elephant & Castle (Underground)",
        "crs": "ZEL"
    },
    {
        "stationName": "Elgin",
        "crs": "ELG"
    },
    {
        "stationName": "Ellesmere Port",
        "crs": "ELP"
    },
    {
        "stationName": "Elmers End",
        "crs": "ELE"
    },
    {
        "stationName": "Elmstead Woods",
        "crs": "ESD"
    },
    {
        "stationName": "Elmswell",
        "crs": "ESW"
    },
    {
        "stationName": "Elsecar",
        "crs": "ELR"
    },
    {
        "stationName": "Elsenham (Essex)",
        "crs": "ESM"
    },
    {
        "stationName": "Elstree & Borehamwood",
        "crs": "ELS"
    },
    {
        "stationName": "Eltham",
        "crs": "ELW"
    },
    {
        "stationName": "Elton & Orston",
        "crs": "ELO"
    },
    {
        "stationName": "Ely",
        "crs": "ELY"
    },
    {
        "stationName": "Emerson Park",
        "crs": "EMP"
    },
    {
        "stationName": "Emsworth",
        "crs": "EMS"
    },
    {
        "stationName": "Energlyn & Churchill Park",
        "crs": "ECP"
    },
    {
        "stationName": "Enfield Chase",
        "crs": "ENC"
    },
    {
        "stationName": "Enfield Lock",
        "crs": "ENL"
    },
    {
        "stationName": "Enfield Town",
        "crs": "ENF"
    },
    {
        "stationName": "Entwistle",
        "crs": "ENT"
    },
    {
        "stationName": "Epsom (Surrey)",
        "crs": "EPS"
    },
    {
        "stationName": "Epsom Downs",
        "crs": "EPD"
    },
    {
        "stationName": "Erdington",
        "crs": "ERD"
    },
    {
        "stationName": "Eridge",
        "crs": "ERI"
    },
    {
        "stationName": "Erith",
        "crs": "ERH"
    },
    {
        "stationName": "Esher",
        "crs": "ESH"
    },
    {
        "stationName": "Eskbank",
        "crs": "EKB"
    },
    {
        "stationName": "Essex Road",
        "crs": "EXR"
    },
    {
        "stationName": "Etchingham",
        "crs": "ETC"
    },
    {
        "stationName": "Euxton Balshaw Lane",
        "crs": "EBA"
    },
    {
        "stationName": "Evesham",
        "crs": "EVE"
    },
    {
        "stationName": "Ewell East",
        "crs": "EWE"
    },
    {
        "stationName": "Ewell West",
        "crs": "EWW"
    },
    {
        "stationName": "Exeter Central",
        "crs": "EXC"
    },
    {
        "stationName": "Exeter St David's",
        "crs": "EXD"
    },
    {
        "stationName": "Exeter St Thomas",
        "crs": "EXT"
    },
    {
        "stationName": "Exhibition Centre (Glasgow)",
        "crs": "EXG"
    },
    {
        "stationName": "Exmouth",
        "crs": "EXM"
    },
    {
        "stationName": "Exton",
        "crs": "EXN"
    },
    {
        "stationName": "Eynsford",
        "crs": "EYN"
    },
    {
        "stationName": "Fairbourne",
        "crs": "FRB"
    },
    {
        "stationName": "Fairfield",
        "crs": "FRF"
    },
    {
        "stationName": "Fairlie",
        "crs": "FRL"
    },
    {
        "stationName": "Fairwater",
        "crs": "FRW"
    },
    {
        "stationName": "Falconwood",
        "crs": "FCN"
    },
    {
        "stationName": "Falkirk Grahamston",
        "crs": "FKG"
    },
    {
        "stationName": "Falkirk High",
        "crs": "FKK"
    },
    {
        "stationName": "Falls of Cruachan",
        "crs": "FOC"
    },
    {
        "stationName": "Falmer",
        "crs": "FMR"
    },
    {
        "stationName": "Falmouth Docks",
        "crs": "FAL"
    },
    {
        "stationName": "Falmouth Town",
        "crs": "FMT"
    },
    {
        "stationName": "Fareham",
        "crs": "FRM"
    },
    {
        "stationName": "Farnborough (Main)",
        "crs": "FNB"
    },
    {
        "stationName": "Farnborough North",
        "crs": "FNN"
    },
    {
        "stationName": "Farncombe",
        "crs": "FNC"
    },
    {
        "stationName": "Farnham",
        "crs": "FNH"
    },
    {
        "stationName": "Farningham Road",
        "crs": "FNR"
    },
    {
        "stationName": "Farnworth",
        "crs": "FNW"
    },
    {
        "stationName": "Farringdon",
        "crs": "ZFD"
    },
    {
        "stationName": "Fauldhouse",
        "crs": "FLD"
    },
    {
        "stationName": "Faversham",
        "crs": "FAV"
    },
    {
        "stationName": "Faygate",
        "crs": "FGT"
    },
    {
        "stationName": "Fazakerley",
        "crs": "FAZ"
    },
    {
        "stationName": "Fearn",
        "crs": "FRN"
    },
    {
        "stationName": "Featherstone",
        "crs": "FEA"
    },
    {
        "stationName": "Felixstowe",
        "crs": "FLX"
    },
    {
        "stationName": "Feltham",
        "crs": "FEL"
    },
    {
        "stationName": "Feniton",
        "crs": "FNT"
    },
    {
        "stationName": "Fenny Stratford",
        "crs": "FEN"
    },
    {
        "stationName": "Fernhill",
        "crs": "FER"
    },
    {
        "stationName": "Ferriby",
        "crs": "FRY"
    },
    {
        "stationName": "Ferryside",
        "crs": "FYS"
    },
    {
        "stationName": "Ffairfach",
        "crs": "FFA"
    },
    {
        "stationName": "Filey",
        "crs": "FIL"
    },
    {
        "stationName": "Filton Abbey Wood",
        "crs": "FIT"
    },
    {
        "stationName": "Finchley Road & Frognal",
        "crs": "FNY"
    },
    {
        "stationName": "Finsbury Park",
        "crs": "FPK"
    },
    {
        "stationName": "Finstock",
        "crs": "FIN"
    },
    {
        "stationName": "Fishbourne (Sussex)",
        "crs": "FSB"
    },
    {
        "stationName": "Fishersgate",
        "crs": "FSG"
    },
    {
        "stationName": "Fishguard & Goodwick",
        "crs": "FGW"
    },
    {
        "stationName": "Fishguard Harbour",
        "crs": "FGH"
    },
    {
        "stationName": "Fiskerton",
        "crs": "FSK"
    },
    {
        "stationName": "Fitzwilliam",
        "crs": "FZW"
    },
    {
        "stationName": "Five Ways",
        "crs": "FWY"
    },
    {
        "stationName": "Fleet",
        "crs": "FLE"
    },
    {
        "stationName": "Flimby",
        "crs": "FLM"
    },
    {
        "stationName": "Flint",
        "crs": "FLN"
    },
    {
        "stationName": "Flitwick",
        "crs": "FLT"
    },
    {
        "stationName": "Flixton",
        "crs": "FLI"
    },
    {
        "stationName": "Flowery Field",
        "crs": "FLF"
    },
    {
        "stationName": "Folkestone Central",
        "crs": "FKC"
    },
    {
        "stationName": "Folkestone West",
        "crs": "FKW"
    },
    {
        "stationName": "Ford",
        "crs": "FOD"
    },
    {
        "stationName": "Forest Gate",
        "crs": "FOG"
    },
    {
        "stationName": "Forest Hill",
        "crs": "FOH"
    },
    {
        "stationName": "Formby",
        "crs": "FBY"
    },
    {
        "stationName": "Forres",
        "crs": "FOR"
    },
    {
        "stationName": "Forsinard",
        "crs": "FRS"
    },
    {
        "stationName": "Fort Matilda",
        "crs": "FTM"
    },
    {
        "stationName": "Fort William",
        "crs": "FTW"
    },
    {
        "stationName": "Four Oaks",
        "crs": "FOK"
    },
    {
        "stationName": "Foxfield",
        "crs": "FOX"
    },
    {
        "stationName": "Foxton",
        "crs": "FXN"
    },
    {
        "stationName": "Frant",
        "crs": "FRT"
    },
    {
        "stationName": "Fratton",
        "crs": "FTN"
    },
    {
        "stationName": "Freshfield",
        "crs": "FRE"
    },
    {
        "stationName": "Freshford",
        "crs": "FFD"
    },
    {
        "stationName": "Frimley",
        "crs": "FML"
    },
    {
        "stationName": "Frinton-on-Sea",
        "crs": "FRI"
    },
    {
        "stationName": "Frizinghall",
        "crs": "FZH"
    },
    {
        "stationName": "Frodsham",
        "crs": "FRD"
    },
    {
        "stationName": "Frome",
        "crs": "FRO"
    },
    {
        "stationName": "Fulwell",
        "crs": "FLW"
    },
    {
        "stationName": "Furness Vale",
        "crs": "FNV"
    },
    {
        "stationName": "Furze Platt",
        "crs": "FZP"
    },
    {
        "stationName": "Gainsborough Central",
        "crs": "GNB"
    },
    {
        "stationName": "Gainsborough Lea Road",
        "crs": "GBL"
    },
    {
        "stationName": "Galashiels",
        "crs": "GAL"
    },
    {
        "stationName": "Garelochhead",
        "crs": "GCH"
    },
    {
        "stationName": "Garforth",
        "crs": "GRF"
    },
    {
        "stationName": "Gargrave",
        "crs": "GGV"
    },
    {
        "stationName": "Garrowhill",
        "crs": "GAR"
    },
    {
        "stationName": "Garscadden",
        "crs": "GRS"
    },
    {
        "stationName": "Garsdale",
        "crs": "GSD"
    },
    {
        "stationName": "Garston (Hertfordshire)",
        "crs": "GSN"
    },
    {
        "stationName": "Garswood",
        "crs": "GSW"
    },
    {
        "stationName": "Gartcosh",
        "crs": "GRH"
    },
    {
        "stationName": "Garth (Mid Glamorgan)",
        "crs": "GMG"
    },
    {
        "stationName": "Garth (Powys)",
        "crs": "GTH"
    },
    {
        "stationName": "Garve",
        "crs": "GVE"
    },
    {
        "stationName": "Gathurst",
        "crs": "GST"
    },
    {
        "stationName": "Gatley",
        "crs": "GTY"
    },
    {
        "stationName": "Gatwick Airport",
        "crs": "GTW"
    },
    {
        "stationName": "Georgemas Junction",
        "crs": "GGJ"
    },
    {
        "stationName": "Gerrards Cross",
        "crs": "GER"
    },
    {
        "stationName": "Gidea Park",
        "crs": "GDP"
    },
    {
        "stationName": "Giffnock",
        "crs": "GFN"
    },
    {
        "stationName": "Giggleswick",
        "crs": "GIG"
    },
    {
        "stationName": "Gilberdyke",
        "crs": "GBD"
    },
    {
        "stationName": "Gilfach Fargoed",
        "crs": "GFF"
    },
    {
        "stationName": "Gillingham (Dorset)",
        "crs": "GIL"
    },
    {
        "stationName": "Gillingham (Kent)",
        "crs": "GLM"
    },
    {
        "stationName": "Gilshochill",
        "crs": "GSC"
    },
    {
        "stationName": "Gipsy Hill",
        "crs": "GIP"
    },
    {
        "stationName": "Girvan",
        "crs": "GIR"
    },
    {
        "stationName": "Glaisdale",
        "crs": "GLS"
    },
    {
        "stationName": "Glan Conwy",
        "crs": "GCW"
    },
    {
        "stationName": "Glasgow Central",
        "crs": "GLC"
    },
    {
        "stationName": "Glasgow Queen Street",
        "crs": "GLQ"
    },
    {
        "stationName": "Glasshoughton",
        "crs": "GLH"
    },
    {
        "stationName": "Glazebrook",
        "crs": "GLZ"
    },
    {
        "stationName": "Gleneagles",
        "crs": "GLE"
    },
    {
        "stationName": "Glenfinnan",
        "crs": "GLF"
    },
    {
        "stationName": "Glengarnock",
        "crs": "GLG"
    },
    {
        "stationName": "Glenrothes with Thornton",
        "crs": "GLT"
    },
    {
        "stationName": "Glossop",
        "crs": "GLO"
    },
    {
        "stationName": "Gloucester",
        "crs": "GCR"
    },
    {
        "stationName": "Glynde",
        "crs": "GLY"
    },
    {
        "stationName": "Gobowen",
        "crs": "GOB"
    },
    {
        "stationName": "Godalming",
        "crs": "GOD"
    },
    {
        "stationName": "Godley",
        "crs": "GDL"
    },
    {
        "stationName": "Godstone",
        "crs": "GDN"
    },
    {
        "stationName": "Goldthorpe",
        "crs": "GOE"
    },
    {
        "stationName": "Golf Street",
        "crs": "GOF"
    },
    {
        "stationName": "Golspie",
        "crs": "GOL"
    },
    {
        "stationName": "Gomshall",
        "crs": "GOM"
    },
    {
        "stationName": "Goodmayes",
        "crs": "GMY"
    },
    {
        "stationName": "Goole",
        "crs": "GOO"
    },
    {
        "stationName": "Goostrey",
        "crs": "GTR"
    },
    {
        "stationName": "Gordon Hill",
        "crs": "GDH"
    },
    {
        "stationName": "Gorebridge",
        "crs": "GBG"
    },
    {
        "stationName": "Goring & Streatley",
        "crs": "GOR"
    },
    {
        "stationName": "Goring-by-Sea",
        "crs": "GBS"
    },
    {
        "stationName": "Gorton",
        "crs": "GTO"
    },
    {
        "stationName": "Gospel Oak",
        "crs": "GPO"
    },
    {
        "stationName": "Gourock",
        "crs": "GRK"
    },
    {
        "stationName": "Gowerton",
        "crs": "GWN"
    },
    {
        "stationName": "Goxhill",
        "crs": "GOX"
    },
    {
        "stationName": "Grange Park",
        "crs": "GPK"
    },
    {
        "stationName": "Grange-Over-Sands",
        "crs": "GOS"
    },
    {
        "stationName": "Grangetown (Cardiff)",
        "crs": "GTN"
    },
    {
        "stationName": "Grantham",
        "crs": "GRA"
    },
    {
        "stationName": "Grateley",
        "crs": "GRT"
    },
    {
        "stationName": "Gravelly Hill",
        "crs": "GVH"
    },
    {
        "stationName": "Gravesend",
        "crs": "GRV"
    },
    {
        "stationName": "Grays",
        "crs": "GRY"
    },
    {
        "stationName": "Great Ayton",
        "crs": "GTA"
    },
    {
        "stationName": "Great Bentley",
        "crs": "GRB"
    },
    {
        "stationName": "Great Chesterford",
        "crs": "GRC"
    },
    {
        "stationName": "Great Coates",
        "crs": "GCT"
    },
    {
        "stationName": "Great Malvern",
        "crs": "GMV"
    },
    {
        "stationName": "Great Missenden",
        "crs": "GMN"
    },
    {
        "stationName": "Great Yarmouth",
        "crs": "GYM"
    },
    {
        "stationName": "Green Lane",
        "crs": "GNL"
    },
    {
        "stationName": "Green Road",
        "crs": "GNR"
    },
    {
        "stationName": "Greenbank",
        "crs": "GBK"
    },
    {
        "stationName": "Greenfaulds",
        "crs": "GRL"
    },
    {
        "stationName": "Greenfield",
        "crs": "GNF"
    },
    {
        "stationName": "Greenford",
        "crs": "GFD"
    },
    {
        "stationName": "Greenhithe",
        "crs": "GNH"
    },
    {
        "stationName": "Greenock Central",
        "crs": "GKC"
    },
    {
        "stationName": "Greenock West",
        "crs": "GKW"
    },
    {
        "stationName": "Greenwich",
        "crs": "GNW"
    },
    {
        "stationName": "Gretna Green",
        "crs": "GEA"
    },
    {
        "stationName": "Grimsby Docks",
        "crs": "GMD"
    },
    {
        "stationName": "Grimsby Town",
        "crs": "GMB"
    },
    {
        "stationName": "Grindleford",
        "crs": "GRN"
    },
    {
        "stationName": "Grosmont",
        "crs": "GMT"
    },
    {
        "stationName": "Grove Park",
        "crs": "GRP"
    },
    {
        "stationName": "Guide Bridge",
        "crs": "GUI"
    },
    {
        "stationName": "Guildford",
        "crs": "GLD"
    },
    {
        "stationName": "Guiseley",
        "crs": "GSY"
    },
    {
        "stationName": "Gunnersbury",
        "crs": "GUN"
    },
    {
        "stationName": "Gunnislake",
        "crs": "GSL"
    },
    {
        "stationName": "Gunton",
        "crs": "GNT"
    },
    {
        "stationName": "Gwersyllt",
        "crs": "GWE"
    },
    {
        "stationName": "Gypsy Lane",
        "crs": "GYP"
    },
    {
        "stationName": "Habrough",
        "crs": "HAB"
    },
    {
        "stationName": "Hackbridge",
        "crs": "HCB"
    },
    {
        "stationName": "Hackney Central",
        "crs": "HKC"
    },
    {
        "stationName": "Hackney Downs",
        "crs": "HAC"
    },
    {
        "stationName": "Hackney Wick",
        "crs": "HKW"
    },
    {
        "stationName": "Haddenham & Thame Parkway",
        "crs": "HDM"
    },
    {
        "stationName": "Haddiscoe",
        "crs": "HAD"
    },
    {
        "stationName": "Hadfield",
        "crs": "HDF"
    },
    {
        "stationName": "Hadley Wood",
        "crs": "HDW"
    },
    {
        "stationName": "Hag Fold",
        "crs": "HGF"
    },
    {
        "stationName": "Haggerston",
        "crs": "HGG"
    },
    {
        "stationName": "Hagley",
        "crs": "HAG"
    },
    {
        "stationName": "Hairmyres",
        "crs": "HMY"
    },
    {
        "stationName": "Hale (Manchester)",
        "crs": "HAL"
    },
    {
        "stationName": "Halesworth",
        "crs": "HAS"
    },
    {
        "stationName": "Halewood",
        "crs": "HED"
    },
    {
        "stationName": "Halifax",
        "crs": "HFX"
    },
    {
        "stationName": "Hall Green",
        "crs": "HLG"
    },
    {
        "stationName": "Hall Road",
        "crs": "HLR"
    },
    {
        "stationName": "Halling",
        "crs": "HAI"
    },
    {
        "stationName": "Hall-i'-th'-Wood",
        "crs": "HID"
    },
    {
        "stationName": "Haltwhistle",
        "crs": "HWH"
    },
    {
        "stationName": "Ham Street",
        "crs": "HMT"
    },
    {
        "stationName": "Hamble",
        "crs": "HME"
    },
    {
        "stationName": "Hamilton Central",
        "crs": "HNC"
    },
    {
        "stationName": "Hamilton West",
        "crs": "HNW"
    },
    {
        "stationName": "Hammerton",
        "crs": "HMM"
    },
    {
        "stationName": "Hampden Park (Sussex)",
        "crs": "HMD"
    },
    {
        "stationName": "Hampstead Heath",
        "crs": "HDH"
    },
    {
        "stationName": "Hampton (London)",
        "crs": "HMP"
    },
    {
        "stationName": "Hampton Court",
        "crs": "HMC"
    },
    {
        "stationName": "Hampton Wick",
        "crs": "HMW"
    },
    {
        "stationName": "Hampton-in-Arden",
        "crs": "HIA"
    },
    {
        "stationName": "Hamstead (Birmingham)",
        "crs": "HSD"
    },
    {
        "stationName": "Hamworthy",
        "crs": "HAM"
    },
    {
        "stationName": "Hanborough",
        "crs": "HND"
    },
    {
        "stationName": "Handforth",
        "crs": "HTH"
    },
    {
        "stationName": "Hanwell",
        "crs": "HAN"
    },
    {
        "stationName": "Hapton",
        "crs": "HPN"
    },
    {
        "stationName": "Harlech",
        "crs": "HRL"
    },
    {
        "stationName": "Harlesden",
        "crs": "HDN"
    },
    {
        "stationName": "Harling Road",
        "crs": "HRD"
    },
    {
        "stationName": "Harlington (Beds)",
        "crs": "HLN"
    },
    {
        "stationName": "Harlow Mill",
        "crs": "HWM"
    },
    {
        "stationName": "Harlow Town",
        "crs": "HWN"
    },
    {
        "stationName": "Harold Wood",
        "crs": "HRO"
    },
    {
        "stationName": "Harpenden",
        "crs": "HPD"
    },
    {
        "stationName": "Harrietsham",
        "crs": "HRM"
    },
    {
        "stationName": "Harringay",
        "crs": "HGY"
    },
    {
        "stationName": "Harringay Green Lanes",
        "crs": "HRY"
    },
    {
        "stationName": "Harrington",
        "crs": "HRR"
    },
    {
        "stationName": "Harrogate",
        "crs": "HGT"
    },
    {
        "stationName": "Harrow & Wealdstone",
        "crs": "HRW"
    },
    {
        "stationName": "Harrow-on-the-Hill",
        "crs": "HOH"
    },
    {
        "stationName": "Hartford (Cheshire)",
        "crs": "HTF"
    },
    {
        "stationName": "Hartlebury",
        "crs": "HBY"
    },
    {
        "stationName": "Hartlepool",
        "crs": "HPL"
    },
    {
        "stationName": "Hartwood",
        "crs": "HTW"
    },
    {
        "stationName": "Harwich International",
        "crs": "HPQ"
    },
    {
        "stationName": "Harwich Town",
        "crs": "HWC"
    },
    {
        "stationName": "Haslemere",
        "crs": "HSL"
    },
    {
        "stationName": "Hassocks",
        "crs": "HSK"
    },
    {
        "stationName": "Hastings",
        "crs": "HGS"
    },
    {
        "stationName": "Hatch End",
        "crs": "HTE"
    },
    {
        "stationName": "Hatfield & Stainforth",
        "crs": "HFS"
    },
    {
        "stationName": "Hatfield (Herts)",
        "crs": "HAT"
    },
    {
        "stationName": "Hatfield Peverel",
        "crs": "HAP"
    },
    {
        "stationName": "Hathersage",
        "crs": "HSG"
    },
    {
        "stationName": "Hattersley",
        "crs": "HTY"
    },
    {
        "stationName": "Hatton",
        "crs": "HTN"
    },
    {
        "stationName": "Havant",
        "crs": "HAV"
    },
    {
        "stationName": "Havenhouse",
        "crs": "HVN"
    },
    {
        "stationName": "Haverfordwest",
        "crs": "HVF"
    },
    {
        "stationName": "Hawarden",
        "crs": "HWD"
    },
    {
        "stationName": "Hawarden Bridge",
        "crs": "HWB"
    },
    {
        "stationName": "Hawkhead",
        "crs": "HKH"
    },
    {
        "stationName": "Haydon Bridge",
        "crs": "HDB"
    },
    {
        "stationName": "Haydons Road",
        "crs": "HYR"
    },
    {
        "stationName": "Hayes & Harlington",
        "crs": "HAY"
    },
    {
        "stationName": "Hayes (Kent)",
        "crs": "HYS"
    },
    {
        "stationName": "Hayle",
        "crs": "HYL"
    },
    {
        "stationName": "Haymarket",
        "crs": "HYM"
    },
    {
        "stationName": "Haywards Heath",
        "crs": "HHE"
    },
    {
        "stationName": "Hazel Grove",
        "crs": "HAZ"
    },
    {
        "stationName": "Headcorn",
        "crs": "HCN"
    },
    {
        "stationName": "Headingley",
        "crs": "HDY"
    },
    {
        "stationName": "Headstone Lane",
        "crs": "HDL"
    },
    {
        "stationName": "Heald Green",
        "crs": "HDG"
    },
    {
        "stationName": "Healing",
        "crs": "HLI"
    },
    {
        "stationName": "Heath High Level",
        "crs": "HHL"
    },
    {
        "stationName": "Heath Low Level",
        "crs": "HLL"
    },
    {
        "stationName": "Heathrow Airport Terminal 4",
        "crs": "HAF"
    },
    {
        "stationName": "Heathrow Airport Terminal 5",
        "crs": "HWV"
    },
    {
        "stationName": "Heathrow Airport Terminals 1, 2 and 3",
        "crs": "HXX"
    },
    {
        "stationName": "Heaton Chapel",
        "crs": "HTC"
    },
    {
        "stationName": "Hebden Bridge",
        "crs": "HBD"
    },
    {
        "stationName": "Heckington",
        "crs": "HEC"
    },
    {
        "stationName": "Hedge End",
        "crs": "HDE"
    },
    {
        "stationName": "Hednesford",
        "crs": "HNF"
    },
    {
        "stationName": "Heighington",
        "crs": "HEI"
    },
    {
        "stationName": "Helensburgh Central",
        "crs": "HLC"
    },
    {
        "stationName": "Helensburgh Upper",
        "crs": "HLU"
    },
    {
        "stationName": "Hellifield",
        "crs": "HLD"
    },
    {
        "stationName": "Helmsdale",
        "crs": "HMS"
    },
    {
        "stationName": "Helsby",
        "crs": "HSB"
    },
    {
        "stationName": "Hemel Hempstead",
        "crs": "HML"
    },
    {
        "stationName": "Hendon",
        "crs": "HEN"
    },
    {
        "stationName": "Hengoed",
        "crs": "HNG"
    },
    {
        "stationName": "Henley-in-Arden",
        "crs": "HNL"
    },
    {
        "stationName": "Henley-on-Thames",
        "crs": "HOT"
    },
    {
        "stationName": "Hensall",
        "crs": "HEL"
    },
    {
        "stationName": "Hereford",
        "crs": "HFD"
    },
    {
        "stationName": "Herne Bay",
        "crs": "HNB"
    },
    {
        "stationName": "Herne Hill",
        "crs": "HNH"
    },
    {
        "stationName": "Hersham",
        "crs": "HER"
    },
    {
        "stationName": "Hertford East",
        "crs": "HFE"
    },
    {
        "stationName": "Hertford North",
        "crs": "HFN"
    },
    {
        "stationName": "Hessle",
        "crs": "HES"
    },
    {
        "stationName": "Heswall",
        "crs": "HSW"
    },
    {
        "stationName": "Hever",
        "crs": "HEV"
    },
    {
        "stationName": "Heworth",
        "crs": "HEW"
    },
    {
        "stationName": "Hexham",
        "crs": "HEX"
    },
    {
        "stationName": "Heyford",
        "crs": "HYD"
    },
    {
        "stationName": "Heysham Port",
        "crs": "HHB"
    },
    {
        "stationName": "High Brooms",
        "crs": "HIB"
    },
    {
        "stationName": "High Street (Glasgow)",
        "crs": "HST"
    },
    {
        "stationName": "High Street Kensington Underground",
        "crs": "ZHS"
    },
    {
        "stationName": "High Wycombe",
        "crs": "HWY"
    },
    {
        "stationName": "Higham (Kent)",
        "crs": "HGM"
    },
    {
        "stationName": "Highams Park",
        "crs": "HIP"
    },
    {
        "stationName": "Highbridge & Burnham",
        "crs": "HIG"
    },
    {
        "stationName": "Highbury & Islington",
        "crs": "HHY"
    },
    {
        "stationName": "Hightown",
        "crs": "HTO"
    },
    {
        "stationName": "Hildenborough",
        "crs": "HLB"
    },
    {
        "stationName": "Hillfoot",
        "crs": "HLF"
    },
    {
        "stationName": "Hillington East",
        "crs": "HLE"
    },
    {
        "stationName": "Hillington West",
        "crs": "HLW"
    },
    {
        "stationName": "Hillside",
        "crs": "HIL"
    },
    {
        "stationName": "Hilsea",
        "crs": "HLS"
    },
    {
        "stationName": "Hinchley Wood",
        "crs": "HYW"
    },
    {
        "stationName": "Hinckley (Leics)",
        "crs": "HNK"
    },
    {
        "stationName": "Hindley",
        "crs": "HIN"
    },
    {
        "stationName": "Hinton Admiral",
        "crs": "HNA"
    },
    {
        "stationName": "Hitchin",
        "crs": "HIT"
    },
    {
        "stationName": "Hither Green",
        "crs": "HGR"
    },
    {
        "stationName": "Hockley",
        "crs": "HOC"
    },
    {
        "stationName": "Hollingbourne",
        "crs": "HBN"
    },
    {
        "stationName": "Holmes Chapel",
        "crs": "HCH"
    },
    {
        "stationName": "Holmwood",
        "crs": "HLM"
    },
    {
        "stationName": "Holton Heath",
        "crs": "HOL"
    },
    {
        "stationName": "Holyhead",
        "crs": "HHD"
    },
    {
        "stationName": "Holytown",
        "crs": "HLY"
    },
    {
        "stationName": "Homerton",
        "crs": "HMN"
    },
    {
        "stationName": "Honeybourne",
        "crs": "HYB"
    },
    {
        "stationName": "Honiton",
        "crs": "HON"
    },
    {
        "stationName": "Honley",
        "crs": "HOY"
    },
    {
        "stationName": "Honor Oak Park",
        "crs": "HPA"
    },
    {
        "stationName": "Hook",
        "crs": "HOK"
    },
    {
        "stationName": "Hooton",
        "crs": "HOO"
    },
    {
        "stationName": "Hope (Derbyshire)",
        "crs": "HOP"
    },
    {
        "stationName": "Hope (Flintshire)",
        "crs": "HPE"
    },
    {
        "stationName": "Hopton Heath",
        "crs": "HPT"
    },
    {
        "stationName": "Horden",
        "crs": "HRE"
    },
    {
        "stationName": "Horley",
        "crs": "HOR"
    },
    {
        "stationName": "Hornbeam Park",
        "crs": "HBP"
    },
    {
        "stationName": "Hornsey",
        "crs": "HRN"
    },
    {
        "stationName": "Horsforth",
        "crs": "HRS"
    },
    {
        "stationName": "Horsham",
        "crs": "HRH"
    },
    {
        "stationName": "Horsley",
        "crs": "HSY"
    },
    {
        "stationName": "Horton-in-Ribblesdale",
        "crs": "HIR"
    },
    {
        "stationName": "Horwich Parkway",
        "crs": "HWI"
    },
    {
        "stationName": "Hoscar",
        "crs": "HSC"
    },
    {
        "stationName": "Hough Green",
        "crs": "HGN"
    },
    {
        "stationName": "Hounslow",
        "crs": "HOU"
    },
    {
        "stationName": "Hove",
        "crs": "HOV"
    },
    {
        "stationName": "Hoveton & Wroxham",
        "crs": "HXM"
    },
    {
        "stationName": "How Wood (Herts)",
        "crs": "HWW"
    },
    {
        "stationName": "Howden",
        "crs": "HOW"
    },
    {
        "stationName": "Howwood (Renfrewshire)",
        "crs": "HOZ"
    },
    {
        "stationName": "Hoxton",
        "crs": "HOX"
    },
    {
        "stationName": "Hoylake",
        "crs": "HYK"
    },
    {
        "stationName": "Hubberts Bridge",
        "crs": "HBB"
    },
    {
        "stationName": "Hucknall",
        "crs": "HKN"
    },
    {
        "stationName": "Huddersfield",
        "crs": "HUD"
    },
    {
        "stationName": "Hull",
        "crs": "HUL"
    },
    {
        "stationName": "Humphrey Park",
        "crs": "HUP"
    },
    {
        "stationName": "Huncoat",
        "crs": "HCT"
    },
    {
        "stationName": "Hungerford",
        "crs": "HGD"
    },
    {
        "stationName": "Hunmanby",
        "crs": "HUB"
    },
    {
        "stationName": "Huntingdon",
        "crs": "HUN"
    },
    {
        "stationName": "Huntly",
        "crs": "HNT"
    },
    {
        "stationName": "Hunts Cross",
        "crs": "HNX"
    },
    {
        "stationName": "Hurst Green",
        "crs": "HUR"
    },
    {
        "stationName": "Hutton Cranswick",
        "crs": "HUT"
    },
    {
        "stationName": "Huyton",
        "crs": "HUY"
    },
    {
        "stationName": "Hyde Central",
        "crs": "HYC"
    },
    {
        "stationName": "Hyde North",
        "crs": "HYT"
    },
    {
        "stationName": "Hykeham",
        "crs": "HKM"
    },
    {
        "stationName": "Hyndland",
        "crs": "HYN"
    },
    {
        "stationName": "Hythe (Essex)",
        "crs": "HYH"
    },
    {
        "stationName": "IBM Halt",
        "crs": "IBM"
    },
    {
        "stationName": "Ifield",
        "crs": "IFI"
    },
    {
        "stationName": "Ilford",
        "crs": "IFD"
    },
    {
        "stationName": "Ilkeston",
        "crs": "ILN"
    },
    {
        "stationName": "Ilkley",
        "crs": "ILK"
    },
    {
        "stationName": "Imperial Wharf",
        "crs": "IMW"
    },
    {
        "stationName": "Ince & Elton",
        "crs": "INE"
    },
    {
        "stationName": "Ince (Manchester)",
        "crs": "INC"
    },
    {
        "stationName": "Ingatestone",
        "crs": "INT"
    },
    {
        "stationName": "Insch",
        "crs": "INS"
    },
    {
        "stationName": "Invergordon",
        "crs": "IGD"
    },
    {
        "stationName": "Invergowrie",
        "crs": "ING"
    },
    {
        "stationName": "Inverkeithing",
        "crs": "INK"
    },
    {
        "stationName": "Inverkip",
        "crs": "INP"
    },
    {
        "stationName": "Inverness",
        "crs": "INV"
    },
    {
        "stationName": "Invershin",
        "crs": "INH"
    },
    {
        "stationName": "Inverurie",
        "crs": "INR"
    },
    {
        "stationName": "Ipswich",
        "crs": "IPS"
    },
    {
        "stationName": "Irlam",
        "crs": "IRL"
    },
    {
        "stationName": "Irvine",
        "crs": "IRV"
    },
    {
        "stationName": "Isleworth",
        "crs": "ISL"
    },
    {
        "stationName": "Islip",
        "crs": "ISP"
    },
    {
        "stationName": "Iver",
        "crs": "IVR"
    },
    {
        "stationName": "Ivybridge",
        "crs": "IVY"
    },
    {
        "stationName": "James Cook",
        "crs": "JCH"
    },
    {
        "stationName": "Jewellery Quarter",
        "crs": "JEQ"
    },
    {
        "stationName": "Johnston (Pembs)",
        "crs": "JOH"
    },
    {
        "stationName": "Johnstone (Strathclyde)",
        "crs": "JHN"
    },
    {
        "stationName": "Jordanhill",
        "crs": "JOR"
    },
    {
        "stationName": "Kearsley (Manchester)",
        "crs": "KSL"
    },
    {
        "stationName": "Kearsney (Kent)",
        "crs": "KSN"
    },
    {
        "stationName": "Keighley",
        "crs": "KEI"
    },
    {
        "stationName": "Keith",
        "crs": "KEH"
    },
    {
        "stationName": "Kelvedon",
        "crs": "KEL"
    },
    {
        "stationName": "Kelvindale",
        "crs": "KVD"
    },
    {
        "stationName": "Kemble",
        "crs": "KEM"
    },
    {
        "stationName": "Kempston Hardwick",
        "crs": "KMH"
    },
    {
        "stationName": "Kempton Park Racecourse",
        "crs": "KMP"
    },
    {
        "stationName": "Kemsing",
        "crs": "KMS"
    },
    {
        "stationName": "Kemsley",
        "crs": "KML"
    },
    {
        "stationName": "Kendal",
        "crs": "KEN"
    },
    {
        "stationName": "Kenilworth",
        "crs": "KNW"
    },
    {
        "stationName": "Kenley",
        "crs": "KLY"
    },
    {
        "stationName": "Kennett",
        "crs": "KNE"
    },
    {
        "stationName": "Kennishead",
        "crs": "KNS"
    },
    {
        "stationName": "Kensal Green",
        "crs": "KNL"
    },
    {
        "stationName": "Kensal Rise",
        "crs": "KNR"
    },
    {
        "stationName": "Kensington Olympia",
        "crs": "KPA"
    },
    {
        "stationName": "Kent House",
        "crs": "KTH"
    },
    {
        "stationName": "Kentish Town",
        "crs": "KTN"
    },
    {
        "stationName": "Kentish Town West",
        "crs": "KTW"
    },
    {
        "stationName": "Kenton",
        "crs": "KNT"
    },
    {
        "stationName": "Kents Bank",
        "crs": "KBK"
    },
    {
        "stationName": "Kettering",
        "crs": "KET"
    },
    {
        "stationName": "Kew Bridge",
        "crs": "KWB"
    },
    {
        "stationName": "Kew Gardens",
        "crs": "KWG"
    },
    {
        "stationName": "Keyham",
        "crs": "KEY"
    },
    {
        "stationName": "Keynsham",
        "crs": "KYN"
    },
    {
        "stationName": "Kidbrooke",
        "crs": "KDB"
    },
    {
        "stationName": "Kidderminster",
        "crs": "KID"
    },
    {
        "stationName": "Kidsgrove",
        "crs": "KDG"
    },
    {
        "stationName": "Kidwelly",
        "crs": "KWL"
    },
    {
        "stationName": "Kilburn High Road",
        "crs": "KBN"
    },
    {
        "stationName": "Kildale",
        "crs": "KLD"
    },
    {
        "stationName": "Kildonan",
        "crs": "KIL"
    },
    {
        "stationName": "Kilgetty",
        "crs": "KGT"
    },
    {
        "stationName": "Kilmarnock",
        "crs": "KMK"
    },
    {
        "stationName": "Kilmaurs",
        "crs": "KLM"
    },
    {
        "stationName": "Kilpatrick",
        "crs": "KPT"
    },
    {
        "stationName": "Kilwinning",
        "crs": "KWN"
    },
    {
        "stationName": "Kinbrace",
        "crs": "KBC"
    },
    {
        "stationName": "Kingham",
        "crs": "KGM"
    },
    {
        "stationName": "Kinghorn",
        "crs": "KGH"
    },
    {
        "stationName": "Kings Langley",
        "crs": "KGL"
    },
    {
        "stationName": "Kings Lynn",
        "crs": "KLN"
    },
    {
        "stationName": "Kings Norton",
        "crs": "KNN"
    },
    {
        "stationName": "Kings Nympton",
        "crs": "KGN"
    },
    {
        "stationName": "Kings Park",
        "crs": "KGP"
    },
    {
        "stationName": "Kings Sutton",
        "crs": "KGS"
    },
    {
        "stationName": "Kingsknowe",
        "crs": "KGE"
    },
    {
        "stationName": "Kingston",
        "crs": "KNG"
    },
    {
        "stationName": "Kingswood",
        "crs": "KND"
    },
    {
        "stationName": "Kingussie",
        "crs": "KIN"
    },
    {
        "stationName": "Kintbury",
        "crs": "KIT"
    },
    {
        "stationName": "Kirby Cross",
        "crs": "KBX"
    },
    {
        "stationName": "Kirk Sandall",
        "crs": "KKS"
    },
    {
        "stationName": "Kirkby (Merseyside)",
        "crs": "KIR"
    },
    {
        "stationName": "Kirkby Stephen",
        "crs": "KSW"
    },
    {
        "stationName": "Kirkby-in-Ashfield",
        "crs": "KKB"
    },
    {
        "stationName": "Kirkby-in-Furness",
        "crs": "KBF"
    },
    {
        "stationName": "Kirkcaldy",
        "crs": "KDY"
    },
    {
        "stationName": "Kirkconnel",
        "crs": "KRK"
    },
    {
        "stationName": "Kirkdale",
        "crs": "KKD"
    },
    {
        "stationName": "Kirkham & Wesham",
        "crs": "KKM"
    },
    {
        "stationName": "Kirkhill",
        "crs": "KKH"
    },
    {
        "stationName": "Kirknewton",
        "crs": "KKN"
    },
    {
        "stationName": "Kirkstall Forge",
        "crs": "KLF"
    },
    {
        "stationName": "Kirkwood",
        "crs": "KWD"
    },
    {
        "stationName": "Kirton Lindsey",
        "crs": "KTL"
    },
    {
        "stationName": "Kiveton Bridge",
        "crs": "KIV"
    },
    {
        "stationName": "Kiveton Park",
        "crs": "KVP"
    },
    {
        "stationName": "Knaresborough",
        "crs": "KNA"
    },
    {
        "stationName": "Knebworth",
        "crs": "KBW"
    },
    {
        "stationName": "Knighton",
        "crs": "KNI"
    },
    {
        "stationName": "Knockholt",
        "crs": "KCK"
    },
    {
        "stationName": "Knottingley",
        "crs": "KNO"
    },
    {
        "stationName": "Knucklas",
        "crs": "KNU"
    },
    {
        "stationName": "Knutsford",
        "crs": "KNF"
    },
    {
        "stationName": "Kyle of Lochalsh",
        "crs": "KYL"
    },
    {
        "stationName": "Ladybank",
        "crs": "LDY"
    },
    {
        "stationName": "Ladywell",
        "crs": "LAD"
    },
    {
        "stationName": "Laindon",
        "crs": "LAI"
    },
    {
        "stationName": "Lairg",
        "crs": "LRG"
    },
    {
        "stationName": "Lake",
        "crs": "LKE"
    },
    {
        "stationName": "Lakenheath",
        "crs": "LAK"
    },
    {
        "stationName": "Lamphey",
        "crs": "LAM"
    },
    {
        "stationName": "Lanark",
        "crs": "LNK"
    },
    {
        "stationName": "Lancaster",
        "crs": "LAN"
    },
    {
        "stationName": "Lancing",
        "crs": "LAC"
    },
    {
        "stationName": "Landywood",
        "crs": "LAW"
    },
    {
        "stationName": "Langbank",
        "crs": "LGB"
    },
    {
        "stationName": "Langho",
        "crs": "LHO"
    },
    {
        "stationName": "Langley (Berks)",
        "crs": "LNY"
    },
    {
        "stationName": "Langley Green",
        "crs": "LGG"
    },
    {
        "stationName": "Langley Mill",
        "crs": "LGM"
    },
    {
        "stationName": "Langside",
        "crs": "LGS"
    },
    {
        "stationName": "Langwathby",
        "crs": "LGW"
    },
    {
        "stationName": "Langwith-Whaley Thorns",
        "crs": "LAG"
    },
    {
        "stationName": "Lapford",
        "crs": "LAP"
    },
    {
        "stationName": "Lapworth",
        "crs": "LPW"
    },
    {
        "stationName": "Larbert",
        "crs": "LBT"
    },
    {
        "stationName": "Largs",
        "crs": "LAR"
    },
    {
        "stationName": "Larkhall",
        "crs": "LRH"
    },
    {
        "stationName": "Laurencekirk",
        "crs": "LAU"
    },
    {
        "stationName": "Lawrence Hill",
        "crs": "LWH"
    },
    {
        "stationName": "Layton (Lancs)",
        "crs": "LAY"
    },
    {
        "stationName": "Lazonby & Kirkoswald",
        "crs": "LZB"
    },
    {
        "stationName": "Lea Bridge",
        "crs": "LEB"
    },
    {
        "stationName": "Lea Green",
        "crs": "LEG"
    },
    {
        "stationName": "Lea Hall",
        "crs": "LEH"
    },
    {
        "stationName": "Leagrave",
        "crs": "LEA"
    },
    {
        "stationName": "Lealholm",
        "crs": "LHM"
    },
    {
        "stationName": "Leamington Spa",
        "crs": "LMS"
    },
    {
        "stationName": "Leasowe",
        "crs": "LSW"
    },
    {
        "stationName": "Leatherhead",
        "crs": "LHD"
    },
    {
        "stationName": "Ledbury",
        "crs": "LED"
    },
    {
        "stationName": "Lee (London)",
        "crs": "LEE"
    },
    {
        "stationName": "Leeds",
        "crs": "LDS"
    },
    {
        "stationName": "Leicester",
        "crs": "LEI"
    },
    {
        "stationName": "Leigh (Kent)",
        "crs": "LIH"
    },
    {
        "stationName": "Leigh-on-Sea",
        "crs": "LES"
    },
    {
        "stationName": "Leighton Buzzard",
        "crs": "LBZ"
    },
    {
        "stationName": "Lelant",
        "crs": "LEL"
    },
    {
        "stationName": "Lelant Saltings",
        "crs": "LTS"
    },
    {
        "stationName": "Lenham",
        "crs": "LEN"
    },
    {
        "stationName": "Lenzie",
        "crs": "LNZ"
    },
    {
        "stationName": "Leominster",
        "crs": "LEO"
    },
    {
        "stationName": "Letchworth Garden City",
        "crs": "LET"
    },
    {
        "stationName": "Leuchars (for St. Andrews)",
        "crs": "LEU"
    },
    {
        "stationName": "Levenshulme",
        "crs": "LVM"
    },
    {
        "stationName": "Lewes",
        "crs": "LWS"
    },
    {
        "stationName": "Lewisham",
        "crs": "LEW"
    },
    {
        "stationName": "Leyland",
        "crs": "LEY"
    },
    {
        "stationName": "Leyton Midland Road",
        "crs": "LEM"
    },
    {
        "stationName": "Leytonstone High Road",
        "crs": "LER"
    },
    {
        "stationName": "Lichfield City",
        "crs": "LIC"
    },
    {
        "stationName": "Lichfield Trent Valley",
        "crs": "LTV"
    },
    {
        "stationName": "Lidlington",
        "crs": "LID"
    },
    {
        "stationName": "Limehouse",
        "crs": "LHS"
    },
    {
        "stationName": "Lincoln Central",
        "crs": "LCN"
    },
    {
        "stationName": "Lingfield",
        "crs": "LFD"
    },
    {
        "stationName": "Lingwood",
        "crs": "LGD"
    },
    {
        "stationName": "Linlithgow",
        "crs": "LIN"
    },
    {
        "stationName": "Liphook",
        "crs": "LIP"
    },
    {
        "stationName": "Liskeard",
        "crs": "LSK"
    },
    {
        "stationName": "Liss",
        "crs": "LIS"
    },
    {
        "stationName": "Lisvane & Thornhill",
        "crs": "LVT"
    },
    {
        "stationName": "Little Kimble",
        "crs": "LTK"
    },
    {
        "stationName": "Little Sutton",
        "crs": "LTT"
    },
    {
        "stationName": "Littleborough",
        "crs": "LTL"
    },
    {
        "stationName": "Littlehampton",
        "crs": "LIT"
    },
    {
        "stationName": "Littlehaven",
        "crs": "LVN"
    },
    {
        "stationName": "Littleport",
        "crs": "LTP"
    },
    {
        "stationName": "Liverpool Central",
        "crs": "LVC"
    },
    {
        "stationName": "Liverpool James Street",
        "crs": "LVJ"
    },
    {
        "stationName": "Liverpool Lime Street",
        "crs": "LIV"
    },
    {
        "stationName": "Liverpool South Parkway",
        "crs": "LPY"
    },
    {
        "stationName": "Livingston North",
        "crs": "LSN"
    },
    {
        "stationName": "Livingston South",
        "crs": "LVG"
    },
    {
        "stationName": "Llanaber",
        "crs": "LLA"
    },
    {
        "stationName": "Llanbedr",
        "crs": "LBR"
    },
    {
        "stationName": "Llanbister Road",
        "crs": "LLT"
    },
    {
        "stationName": "Llanbradach",
        "crs": "LNB"
    },
    {
        "stationName": "Llandaf",
        "crs": "LLN"
    },
    {
        "stationName": "Llandanwg",
        "crs": "LDN"
    },
    {
        "stationName": "Llandecwyn",
        "crs": "LLC"
    },
    {
        "stationName": "Llandeilo",
        "crs": "LLL"
    },
    {
        "stationName": "Llandovery",
        "crs": "LLV"
    },
    {
        "stationName": "Llandrindod",
        "crs": "LLO"
    },
    {
        "stationName": "Llandudno",
        "crs": "LLD"
    },
    {
        "stationName": "Llandudno Junction",
        "crs": "LLJ"
    },
    {
        "stationName": "Llandybie",
        "crs": "LLI"
    },
    {
        "stationName": "Llanelli",
        "crs": "LLE"
    },
    {
        "stationName": "Llanfairfechan",
        "crs": "LLF"
    },
    {
        "stationName": "Llanfairpwll",
        "crs": "LPG"
    },
    {
        "stationName": "Llangadog",
        "crs": "LLG"
    },
    {
        "stationName": "Llangammarch",
        "crs": "LLM"
    },
    {
        "stationName": "Llangennech",
        "crs": "LLH"
    },
    {
        "stationName": "Llangynllo",
        "crs": "LGO"
    },
    {
        "stationName": "Llanharan",
        "crs": "LLR"
    },
    {
        "stationName": "Llanhilleth",
        "crs": "LTH"
    },
    {
        "stationName": "Llanishen",
        "crs": "LLS"
    },
    {
        "stationName": "Llanrwst",
        "crs": "LWR"
    },
    {
        "stationName": "Llansamlet",
        "crs": "LAS"
    },
    {
        "stationName": "Llantwit Major",
        "crs": "LWM"
    },
    {
        "stationName": "Llanwrda",
        "crs": "LNR"
    },
    {
        "stationName": "Llanwrtyd",
        "crs": "LNW"
    },
    {
        "stationName": "Llwyngwril",
        "crs": "LLW"
    },
    {
        "stationName": "Llwynypia",
        "crs": "LLY"
    },
    {
        "stationName": "Loch Awe",
        "crs": "LHA"
    },
    {
        "stationName": "Loch Eil Outward Bound",
        "crs": "LHE"
    },
    {
        "stationName": "Lochailort",
        "crs": "LCL"
    },
    {
        "stationName": "Locheilside",
        "crs": "LCS"
    },
    {
        "stationName": "Lochgelly",
        "crs": "LCG"
    },
    {
        "stationName": "Lochluichart",
        "crs": "LCC"
    },
    {
        "stationName": "Lochwinnoch",
        "crs": "LHW"
    },
    {
        "stationName": "Lockerbie",
        "crs": "LOC"
    },
    {
        "stationName": "Lockwood",
        "crs": "LCK"
    },
    {
        "stationName": "London Blackfriars",
        "crs": "BFR"
    },
    {
        "stationName": "London Bridge",
        "crs": "LBG"
    },
    {
        "stationName": "London Cannon Street",
        "crs": "CST"
    },
    {
        "stationName": "London Charing Cross",
        "crs": "CHX"
    },
    {
        "stationName": "London Euston",
        "crs": "EUS"
    },
    {
        "stationName": "London Fenchurch Street",
        "crs": "FST"
    },
    {
        "stationName": "London Fields",
        "crs": "LOF"
    },
    {
        "stationName": "London Kings Cross",
        "crs": "KGX"
    },
    {
        "stationName": "London Liverpool Street",
        "crs": "LST"
    },
    {
        "stationName": "London Marylebone",
        "crs": "MYB"
    },
    {
        "stationName": "London Paddington",
        "crs": "PAD"
    },
    {
        "stationName": "London Road (Brighton)",
        "crs": "LRB"
    },
    {
        "stationName": "London Road (Guildford)",
        "crs": "LRD"
    },
    {
        "stationName": "London St Pancras (Intl)",
        "crs": "SPX"
    },
    {
        "stationName": "London St Pancras International",
        "crs": "STP"
    },
    {
        "stationName": "London Victoria",
        "crs": "VIC"
    },
    {
        "stationName": "London Waterloo",
        "crs": "WAT"
    },
    {
        "stationName": "London Waterloo East",
        "crs": "WAE"
    },
    {
        "stationName": "Long Buckby",
        "crs": "LBK"
    },
    {
        "stationName": "Long Eaton",
        "crs": "LGE"
    },
    {
        "stationName": "Long Preston",
        "crs": "LPR"
    },
    {
        "stationName": "Longbeck",
        "crs": "LGK"
    },
    {
        "stationName": "Longbridge",
        "crs": "LOB"
    },
    {
        "stationName": "Longcross",
        "crs": "LNG"
    },
    {
        "stationName": "Longfield",
        "crs": "LGF"
    },
    {
        "stationName": "Longniddry",
        "crs": "LND"
    },
    {
        "stationName": "Longport",
        "crs": "LPT"
    },
    {
        "stationName": "Longton",
        "crs": "LGN"
    },
    {
        "stationName": "Looe",
        "crs": "LOO"
    },
    {
        "stationName": "Lostock",
        "crs": "LOT"
    },
    {
        "stationName": "Lostock Gralam",
        "crs": "LTG"
    },
    {
        "stationName": "Lostock Hall",
        "crs": "LOH"
    },
    {
        "stationName": "Lostwithiel",
        "crs": "LOS"
    },
    {
        "stationName": "Loughborough",
        "crs": "LBO"
    },
    {
        "stationName": "Loughborough Junction",
        "crs": "LGJ"
    },
    {
        "stationName": "Low Moor",
        "crs": "LMR"
    },
    {
        "stationName": "Lowdham",
        "crs": "LOW"
    },
    {
        "stationName": "Lower Sydenham",
        "crs": "LSY"
    },
    {
        "stationName": "Lowestoft",
        "crs": "LWT"
    },
    {
        "stationName": "Ludlow",
        "crs": "LUD"
    },
    {
        "stationName": "Luton",
        "crs": "LUT"
    },
    {
        "stationName": "Luton Airport Parkway",
        "crs": "LTN"
    },
    {
        "stationName": "Luxulyan",
        "crs": "LUX"
    },
    {
        "stationName": "Lydney",
        "crs": "LYD"
    },
    {
        "stationName": "Lye (West Midlands)",
        "crs": "LYE"
    },
    {
        "stationName": "Lymington Pier",
        "crs": "LYP"
    },
    {
        "stationName": "Lymington Town",
        "crs": "LYT"
    },
    {
        "stationName": "Lympstone Commando",
        "crs": "LYC"
    },
    {
        "stationName": "Lympstone Village",
        "crs": "LYM"
    },
    {
        "stationName": "Lytham",
        "crs": "LTM"
    },
    {
        "stationName": "Macclesfield",
        "crs": "MAC"
    },
    {
        "stationName": "Machynlleth",
        "crs": "MCN"
    },
    {
        "stationName": "Maesteg",
        "crs": "MST"
    },
    {
        "stationName": "Maesteg (Ewenny Road)",
        "crs": "MEW"
    },
    {
        "stationName": "Maghull",
        "crs": "MAG"
    },
    {
        "stationName": "Maghull North",
        "crs": "MNS"
    },
    {
        "stationName": "Maiden Newton",
        "crs": "MDN"
    },
    {
        "stationName": "Maidenhead",
        "crs": "MAI"
    },
    {
        "stationName": "Maidstone Barracks",
        "crs": "MDB"
    },
    {
        "stationName": "Maidstone East",
        "crs": "MDE"
    },
    {
        "stationName": "Maidstone West",
        "crs": "MDW"
    },
    {
        "stationName": "Malden Manor",
        "crs": "MAL"
    },
    {
        "stationName": "Mallaig",
        "crs": "MLG"
    },
    {
        "stationName": "Malton",
        "crs": "MLT"
    },
    {
        "stationName": "Malvern Link",
        "crs": "MVL"
    },
    {
        "stationName": "Manchester Airport",
        "crs": "MIA"
    },
    {
        "stationName": "Manchester Oxford Road",
        "crs": "MCO"
    },
    {
        "stationName": "Manchester Piccadilly",
        "crs": "MAN"
    },
    {
        "stationName": "Manchester United Football Ground",
        "crs": "MUF"
    },
    {
        "stationName": "Manchester Victoria",
        "crs": "MCV"
    },
    {
        "stationName": "Manea",
        "crs": "MNE"
    },
    {
        "stationName": "Manningtree",
        "crs": "MNG"
    },
    {
        "stationName": "Manor Park",
        "crs": "MNP"
    },
    {
        "stationName": "Manor Road",
        "crs": "MNR"
    },
    {
        "stationName": "Manorbier",
        "crs": "MRB"
    },
    {
        "stationName": "Manors",
        "crs": "MAS"
    },
    {
        "stationName": "Mansfield",
        "crs": "MFT"
    },
    {
        "stationName": "Mansfield Woodhouse",
        "crs": "MSW"
    },
    {
        "stationName": "March",
        "crs": "MCH"
    },
    {
        "stationName": "Marden (Kent)",
        "crs": "MRN"
    },
    {
        "stationName": "Margate",
        "crs": "MAR"
    },
    {
        "stationName": "Market Harborough",
        "crs": "MHR"
    },
    {
        "stationName": "Market Rasen",
        "crs": "MKR"
    },
    {
        "stationName": "Markinch",
        "crs": "MNC"
    },
    {
        "stationName": "Marks Tey",
        "crs": "MKT"
    },
    {
        "stationName": "Marlow",
        "crs": "MLW"
    },
    {
        "stationName": "Marple",
        "crs": "MPL"
    },
    {
        "stationName": "Marsden (Yorks)",
        "crs": "MSN"
    },
    {
        "stationName": "Marske",
        "crs": "MSK"
    },
    {
        "stationName": "Marston Green",
        "crs": "MGN"
    },
    {
        "stationName": "Martin Mill",
        "crs": "MTM"
    },
    {
        "stationName": "Martins Heron",
        "crs": "MAO"
    },
    {
        "stationName": "Marton",
        "crs": "MTO"
    },
    {
        "stationName": "Maryhill",
        "crs": "MYH"
    },
    {
        "stationName": "Maryland",
        "crs": "MYL"
    },
    {
        "stationName": "Maryport",
        "crs": "MRY"
    },
    {
        "stationName": "Matlock",
        "crs": "MAT"
    },
    {
        "stationName": "Matlock Bath",
        "crs": "MTB"
    },
    {
        "stationName": "Mauldeth Road",
        "crs": "MAU"
    },
    {
        "stationName": "Maxwell Park",
        "crs": "MAX"
    },
    {
        "stationName": "Maybole",
        "crs": "MAY"
    },
    {
        "stationName": "Maze Hill",
        "crs": "MZH"
    },
    {
        "stationName": "Meadowhall",
        "crs": "MHS"
    },
    {
        "stationName": "Meldreth",
        "crs": "MEL"
    },
    {
        "stationName": "Melksham",
        "crs": "MKM"
    },
    {
        "stationName": "Melton (Suffolk)",
        "crs": "MES"
    },
    {
        "stationName": "Melton Mowbray",
        "crs": "MMO"
    },
    {
        "stationName": "Menheniot",
        "crs": "MEN"
    },
    {
        "stationName": "Menston",
        "crs": "MNN"
    },
    {
        "stationName": "Meols",
        "crs": "MEO"
    },
    {
        "stationName": "Meols Cop",
        "crs": "MEC"
    },
    {
        "stationName": "Meopham",
        "crs": "MEP"
    },
    {
        "stationName": "Meridian Water",
        "crs": "MRW"
    },
    {
        "stationName": "Merryton",
        "crs": "MEY"
    },
    {
        "stationName": "Merstham",
        "crs": "MHM"
    },
    {
        "stationName": "Merthyr Tydfil",
        "crs": "MER"
    },
    {
        "stationName": "Merthyr Vale",
        "crs": "MEV"
    },
    {
        "stationName": "Metheringham",
        "crs": "MGM"
    },
    {
        "stationName": "MetroCentre",
        "crs": "MCE"
    },
    {
        "stationName": "Mexborough",
        "crs": "MEX"
    },
    {
        "stationName": "Micheldever",
        "crs": "MIC"
    },
    {
        "stationName": "Micklefield",
        "crs": "MIK"
    },
    {
        "stationName": "Middlesbrough",
        "crs": "MBR"
    },
    {
        "stationName": "Middlewood",
        "crs": "MDL"
    },
    {
        "stationName": "Midgham",
        "crs": "MDG"
    },
    {
        "stationName": "Milford (Surrey)",
        "crs": "MLF"
    },
    {
        "stationName": "Milford Haven",
        "crs": "MFH"
    },
    {
        "stationName": "Mill Hill (Lancs)",
        "crs": "MLH"
    },
    {
        "stationName": "Mill Hill Broadway",
        "crs": "MIL"
    },
    {
        "stationName": "Millbrook (Beds)",
        "crs": "MLB"
    },
    {
        "stationName": "Millbrook (Hants)",
        "crs": "MBK"
    },
    {
        "stationName": "Milliken Park",
        "crs": "MIN"
    },
    {
        "stationName": "Millom",
        "crs": "MLM"
    },
    {
        "stationName": "Mills Hill (Manchester)",
        "crs": "MIH"
    },
    {
        "stationName": "Milngavie",
        "crs": "MLN"
    },
    {
        "stationName": "Milton Keynes Central",
        "crs": "MKC"
    },
    {
        "stationName": "Minffordd",
        "crs": "MFF"
    },
    {
        "stationName": "Minster",
        "crs": "MSR"
    },
    {
        "stationName": "Mirfield",
        "crs": "MIR"
    },
    {
        "stationName": "Mistley",
        "crs": "MIS"
    },
    {
        "stationName": "Mitcham Eastfields",
        "crs": "MTC"
    },
    {
        "stationName": "Mitcham Junction",
        "crs": "MIJ"
    },
    {
        "stationName": "Mobberley",
        "crs": "MOB"
    },
    {
        "stationName": "Monifieth",
        "crs": "MON"
    },
    {
        "stationName": "Monks Risborough",
        "crs": "MRS"
    },
    {
        "stationName": "Montpelier",
        "crs": "MTP"
    },
    {
        "stationName": "Montrose",
        "crs": "MTS"
    },
    {
        "stationName": "Moorfields",
        "crs": "MRF"
    },
    {
        "stationName": "Moorgate",
        "crs": "MOG"
    },
    {
        "stationName": "Moorside",
        "crs": "MSD"
    },
    {
        "stationName": "Moorthorpe",
        "crs": "MRP"
    },
    {
        "stationName": "Morar",
        "crs": "MRR"
    },
    {
        "stationName": "Morchard Road",
        "crs": "MRD"
    },
    {
        "stationName": "Morden South",
        "crs": "MDS"
    },
    {
        "stationName": "Morecambe",
        "crs": "MCM"
    },
    {
        "stationName": "Moreton (Dorset)",
        "crs": "MTN"
    },
    {
        "stationName": "Moreton (Merseyside)",
        "crs": "MRT"
    },
    {
        "stationName": "Moreton-in-Marsh",
        "crs": "MIM"
    },
    {
        "stationName": "Morfa Mawddach",
        "crs": "MFA"
    },
    {
        "stationName": "Morley",
        "crs": "MLY"
    },
    {
        "stationName": "Morpeth",
        "crs": "MPT"
    },
    {
        "stationName": "Mortimer",
        "crs": "MOR"
    },
    {
        "stationName": "Mortlake",
        "crs": "MTL"
    },
    {
        "stationName": "Moses Gate",
        "crs": "MSS"
    },
    {
        "stationName": "Moss Side",
        "crs": "MOS"
    },
    {
        "stationName": "Mossley (Manchester)",
        "crs": "MSL"
    },
    {
        "stationName": "Mossley Hill",
        "crs": "MSH"
    },
    {
        "stationName": "Mosspark",
        "crs": "MPK"
    },
    {
        "stationName": "Moston",
        "crs": "MSO"
    },
    {
        "stationName": "Motherwell",
        "crs": "MTH"
    },
    {
        "stationName": "Motspur Park",
        "crs": "MOT"
    },
    {
        "stationName": "Mottingham",
        "crs": "MTG"
    },
    {
        "stationName": "Mottisfont & Dunbridge",
        "crs": "DBG"
    },
    {
        "stationName": "Mouldsworth",
        "crs": "MLD"
    },
    {
        "stationName": "Moulsecoomb",
        "crs": "MCB"
    },
    {
        "stationName": "Mount Florida",
        "crs": "MFL"
    },
    {
        "stationName": "Mount Vernon",
        "crs": "MTV"
    },
    {
        "stationName": "Mountain Ash",
        "crs": "MTA"
    },
    {
        "stationName": "Muir of Ord",
        "crs": "MOO"
    },
    {
        "stationName": "Muirend",
        "crs": "MUI"
    },
    {
        "stationName": "Musselburgh",
        "crs": "MUB"
    },
    {
        "stationName": "Mytholmroyd",
        "crs": "MYT"
    },
    {
        "stationName": "Nafferton",
        "crs": "NFN"
    },
    {
        "stationName": "Nailsea & Backwell",
        "crs": "NLS"
    },
    {
        "stationName": "Nairn",
        "crs": "NRN"
    },
    {
        "stationName": "Nantwich",
        "crs": "NAN"
    },
    {
        "stationName": "Narberth",
        "crs": "NAR"
    },
    {
        "stationName": "Narborough",
        "crs": "NBR"
    },
    {
        "stationName": "Navigation Road",
        "crs": "NVR"
    },
    {
        "stationName": "Neath",
        "crs": "NTH"
    },
    {
        "stationName": "Needham Market",
        "crs": "NMT"
    },
    {
        "stationName": "Neilston",
        "crs": "NEI"
    },
    {
        "stationName": "Nelson",
        "crs": "NEL"
    },
    {
        "stationName": "Neston",
        "crs": "NES"
    },
    {
        "stationName": "Netherfield",
        "crs": "NET"
    },
    {
        "stationName": "Nethertown",
        "crs": "NRT"
    },
    {
        "stationName": "Netley",
        "crs": "NTL"
    },
    {
        "stationName": "New Barnet",
        "crs": "NBA"
    },
    {
        "stationName": "New Beckenham",
        "crs": "NBC"
    },
    {
        "stationName": "New Brighton",
        "crs": "NBN"
    },
    {
        "stationName": "New Clee",
        "crs": "NCE"
    },
    {
        "stationName": "New Cross",
        "crs": "NWX"
    },
    {
        "stationName": "New Cross Gate",
        "crs": "NXG"
    },
    {
        "stationName": "New Cumnock",
        "crs": "NCK"
    },
    {
        "stationName": "New Eltham",
        "crs": "NEH"
    },
    {
        "stationName": "New Holland",
        "crs": "NHL"
    },
    {
        "stationName": "New Hythe",
        "crs": "NHE"
    },
    {
        "stationName": "New Lane",
        "crs": "NLN"
    },
    {
        "stationName": "New Malden",
        "crs": "NEM"
    },
    {
        "stationName": "New Mills Central",
        "crs": "NMC"
    },
    {
        "stationName": "New Mills Newtown",
        "crs": "NMN"
    },
    {
        "stationName": "New Milton",
        "crs": "NWM"
    },
    {
        "stationName": "New Pudsey",
        "crs": "NPD"
    },
    {
        "stationName": "New Southgate",
        "crs": "NSG"
    },
    {
        "stationName": "Newark Castle",
        "crs": "NCT"
    },
    {
        "stationName": "Newark North Gate",
        "crs": "NNG"
    },
    {
        "stationName": "Newbridge",
        "crs": "NBE"
    },
    {
        "stationName": "Newbury",
        "crs": "NBY"
    },
    {
        "stationName": "Newbury Racecourse",
        "crs": "NRC"
    },
    {
        "stationName": "Newcastle",
        "crs": "NCL"
    },
    {
        "stationName": "Newcourt",
        "crs": "NCO"
    },
    {
        "stationName": "Newcraighall",
        "crs": "NEW"
    },
    {
        "stationName": "Newhaven Harbour",
        "crs": "NVH"
    },
    {
        "stationName": "Newhaven Town",
        "crs": "NVN"
    },
    {
        "stationName": "Newington",
        "crs": "NGT"
    },
    {
        "stationName": "Newmarket",
        "crs": "NMK"
    },
    {
        "stationName": "Newport (Essex)",
        "crs": "NWE"
    },
    {
        "stationName": "Newport (South Wales)",
        "crs": "NWP"
    },
    {
        "stationName": "Newquay",
        "crs": "NQY"
    },
    {
        "stationName": "Newstead",
        "crs": "NSD"
    },
    {
        "stationName": "Newton (Lanark)",
        "crs": "NTN"
    },
    {
        "stationName": "Newton Abbot",
        "crs": "NTA"
    },
    {
        "stationName": "Newton Aycliffe",
        "crs": "NAY"
    },
    {
        "stationName": "Newton for Hyde",
        "crs": "NWN"
    },
    {
        "stationName": "Newton St Cyres",
        "crs": "NTC"
    },
    {
        "stationName": "Newtongrange",
        "crs": "NEG"
    },
    {
        "stationName": "Newton-le-Willows",
        "crs": "NLW"
    },
    {
        "stationName": "Newtonmore",
        "crs": "NWR"
    },
    {
        "stationName": "Newton-on-Ayr",
        "crs": "NOA"
    },
    {
        "stationName": "Newtown (Powys)",
        "crs": "NWT"
    },
    {
        "stationName": "Ninian Park",
        "crs": "NNP"
    },
    {
        "stationName": "Nitshill",
        "crs": "NIT"
    },
    {
        "stationName": "Norbiton",
        "crs": "NBT"
    },
    {
        "stationName": "Norbury",
        "crs": "NRB"
    },
    {
        "stationName": "Normans Bay",
        "crs": "NSB"
    },
    {
        "stationName": "Normanton",
        "crs": "NOR"
    },
    {
        "stationName": "North Berwick",
        "crs": "NBW"
    },
    {
        "stationName": "North Camp",
        "crs": "NCM"
    },
    {
        "stationName": "North Dulwich",
        "crs": "NDL"
    },
    {
        "stationName": "North Fambridge",
        "crs": "NFA"
    },
    {
        "stationName": "North Llanrwst",
        "crs": "NLR"
    },
    {
        "stationName": "North Queensferry",
        "crs": "NQU"
    },
    {
        "stationName": "North Road (Darlington)",
        "crs": "NRD"
    },
    {
        "stationName": "North Sheen",
        "crs": "NSH"
    },
    {
        "stationName": "North Walsham",
        "crs": "NWA"
    },
    {
        "stationName": "North Wembley",
        "crs": "NWB"
    },
    {
        "stationName": "Northallerton",
        "crs": "NTR"
    },
    {
        "stationName": "Northampton",
        "crs": "NMP"
    },
    {
        "stationName": "Northfield",
        "crs": "NFD"
    },
    {
        "stationName": "Northfleet",
        "crs": "NFL"
    },
    {
        "stationName": "Northolt Park",
        "crs": "NLT"
    },
    {
        "stationName": "Northumberland Park",
        "crs": "NUM"
    },
    {
        "stationName": "Northwich",
        "crs": "NWI"
    },
    {
        "stationName": "Norwich",
        "crs": "NRW"
    },
    {
        "stationName": "Norwood Junction",
        "crs": "NWD"
    },
    {
        "stationName": "Nottingham",
        "crs": "NOT"
    },
    {
        "stationName": "Nuneaton",
        "crs": "NUN"
    },
    {
        "stationName": "Nunhead",
        "crs": "NHD"
    },
    {
        "stationName": "Nunthorpe",
        "crs": "NNT"
    },
    {
        "stationName": "Nutbourne",
        "crs": "NUT"
    },
    {
        "stationName": "Nutfield",
        "crs": "NUF"
    },
    {
        "stationName": "Oakengates",
        "crs": "OKN"
    },
    {
        "stationName": "Oakham",
        "crs": "OKM"
    },
    {
        "stationName": "Oakleigh Park",
        "crs": "OKL"
    },
    {
        "stationName": "Oban",
        "crs": "OBN"
    },
    {
        "stationName": "Ockendon",
        "crs": "OCK"
    },
    {
        "stationName": "Ockley",
        "crs": "OLY"
    },
    {
        "stationName": "Okehampton",
        "crs": "OKE"
    },
    {
        "stationName": "Okehampton",
        "crs": "OKE"
    },
    {
        "stationName": "Old Hill",
        "crs": "OHL"
    },
    {
        "stationName": "Old Roan",
        "crs": "ORN"
    },
    {
        "stationName": "Old Street",
        "crs": "OLD"
    },
    {
        "stationName": "Oldfield Park",
        "crs": "OLF"
    },
    {
        "stationName": "Olton",
        "crs": "OLT"
    },
    {
        "stationName": "Ore",
        "crs": "ORE"
    },
    {
        "stationName": "Ormskirk",
        "crs": "OMS"
    },
    {
        "stationName": "Orpington",
        "crs": "ORP"
    },
    {
        "stationName": "Orrell",
        "crs": "ORR"
    },
    {
        "stationName": "Orrell Park",
        "crs": "OPK"
    },
    {
        "stationName": "Otford",
        "crs": "OTF"
    },
    {
        "stationName": "Oulton Broad North",
        "crs": "OUN"
    },
    {
        "stationName": "Oulton Broad South",
        "crs": "OUS"
    },
    {
        "stationName": "Outwood",
        "crs": "OUT"
    },
    {
        "stationName": "Overpool",
        "crs": "OVE"
    },
    {
        "stationName": "Overton",
        "crs": "OVR"
    },
    {
        "stationName": "Oxenholme Lake District",
        "crs": "OXN"
    },
    {
        "stationName": "Oxford",
        "crs": "OXF"
    },
    {
        "stationName": "Oxford Parkway",
        "crs": "OXP"
    },
    {
        "stationName": "Oxshott",
        "crs": "OXS"
    },
    {
        "stationName": "Oxted",
        "crs": "OXT"
    },
    {
        "stationName": "Paddock Wood",
        "crs": "PDW"
    },
    {
        "stationName": "Padgate",
        "crs": "PDG"
    },
    {
        "stationName": "Paignton",
        "crs": "PGN"
    },
    {
        "stationName": "Paisley Canal",
        "crs": "PCN"
    },
    {
        "stationName": "Paisley Gilmour Street",
        "crs": "PYG"
    },
    {
        "stationName": "Paisley St James",
        "crs": "PYJ"
    },
    {
        "stationName": "Palmers Green",
        "crs": "PAL"
    },
    {
        "stationName": "Pangbourne",
        "crs": "PAN"
    },
    {
        "stationName": "Pannal",
        "crs": "PNL"
    },
    {
        "stationName": "Pantyffynnon",
        "crs": "PTF"
    },
    {
        "stationName": "Par",
        "crs": "PAR"
    },
    {
        "stationName": "Parbold",
        "crs": "PBL"
    },
    {
        "stationName": "Park Street",
        "crs": "PKT"
    },
    {
        "stationName": "Parkstone (Dorset)",
        "crs": "PKS"
    },
    {
        "stationName": "Parson Street",
        "crs": "PSN"
    },
    {
        "stationName": "Partick",
        "crs": "PTK"
    },
    {
        "stationName": "Parton",
        "crs": "PRN"
    },
    {
        "stationName": "Patchway",
        "crs": "PWY"
    },
    {
        "stationName": "Patricroft",
        "crs": "PAT"
    },
    {
        "stationName": "Patterton",
        "crs": "PTT"
    },
    {
        "stationName": "Peartree",
        "crs": "PEA"
    },
    {
        "stationName": "Peckham Rye",
        "crs": "PMR"
    },
    {
        "stationName": "Pegswood",
        "crs": "PEG"
    },
    {
        "stationName": "Pemberton",
        "crs": "PEM"
    },
    {
        "stationName": "Pembrey & Burry Port",
        "crs": "PBY"
    },
    {
        "stationName": "Pembroke",
        "crs": "PMB"
    },
    {
        "stationName": "Pembroke Dock",
        "crs": "PMD"
    },
    {
        "stationName": "Penally",
        "crs": "PNA"
    },
    {
        "stationName": "Penarth",
        "crs": "PEN"
    },
    {
        "stationName": "Pencoed",
        "crs": "PCD"
    },
    {
        "stationName": "Pengam",
        "crs": "PGM"
    },
    {
        "stationName": "Penge East",
        "crs": "PNE"
    },
    {
        "stationName": "Penge West",
        "crs": "PNW"
    },
    {
        "stationName": "Penhelig",
        "crs": "PHG"
    },
    {
        "stationName": "Penistone",
        "crs": "PNS"
    },
    {
        "stationName": "Penkridge",
        "crs": "PKG"
    },
    {
        "stationName": "Penmaenmawr",
        "crs": "PMW"
    },
    {
        "stationName": "Penmere",
        "crs": "PNM"
    },
    {
        "stationName": "Penrhiwceiber",
        "crs": "PER"
    },
    {
        "stationName": "Penrhyndeudraeth",
        "crs": "PRH"
    },
    {
        "stationName": "Penrith (North Lakes)",
        "crs": "PNR"
    },
    {
        "stationName": "Penryn (Cornwall)",
        "crs": "PYN"
    },
    {
        "stationName": "Pensarn (Gwynedd)",
        "crs": "PES"
    },
    {
        "stationName": "Penshurst",
        "crs": "PHR"
    },
    {
        "stationName": "Pentre-Bach",
        "crs": "PTB"
    },
    {
        "stationName": "Pen-y-Bont",
        "crs": "PNY"
    },
    {
        "stationName": "Penychain",
        "crs": "PNC"
    },
    {
        "stationName": "Penyffordd",
        "crs": "PNF"
    },
    {
        "stationName": "Penzance",
        "crs": "PNZ"
    },
    {
        "stationName": "Perranwell",
        "crs": "PRW"
    },
    {
        "stationName": "Perry Barr",
        "crs": "PRY"
    },
    {
        "stationName": "Pershore",
        "crs": "PSH"
    },
    {
        "stationName": "Perth",
        "crs": "PTH"
    },
    {
        "stationName": "Peterborough",
        "crs": "PBO"
    },
    {
        "stationName": "Petersfield",
        "crs": "PTR"
    },
    {
        "stationName": "Petts Wood",
        "crs": "PET"
    },
    {
        "stationName": "Pevensey & Westham",
        "crs": "PEV"
    },
    {
        "stationName": "Pevensey Bay",
        "crs": "PEB"
    },
    {
        "stationName": "Pewsey",
        "crs": "PEW"
    },
    {
        "stationName": "Pilning",
        "crs": "PIL"
    },
    {
        "stationName": "Pinhoe",
        "crs": "PIN"
    },
    {
        "stationName": "Pitlochry",
        "crs": "PIT"
    },
    {
        "stationName": "Pitsea",
        "crs": "PSE"
    },
    {
        "stationName": "Pleasington",
        "crs": "PLS"
    },
    {
        "stationName": "Plockton",
        "crs": "PLK"
    },
    {
        "stationName": "Pluckley",
        "crs": "PLC"
    },
    {
        "stationName": "Plumley",
        "crs": "PLM"
    },
    {
        "stationName": "Plumpton",
        "crs": "PMP"
    },
    {
        "stationName": "Plumstead",
        "crs": "PLU"
    },
    {
        "stationName": "Plymouth",
        "crs": "PLY"
    },
    {
        "stationName": "Pokesdown",
        "crs": "POK"
    },
    {
        "stationName": "Polegate",
        "crs": "PLG"
    },
    {
        "stationName": "Polesworth",
        "crs": "PSW"
    },
    {
        "stationName": "Pollokshaws East",
        "crs": "PWE"
    },
    {
        "stationName": "Pollokshaws West",
        "crs": "PWW"
    },
    {
        "stationName": "Pollokshields East",
        "crs": "PLE"
    },
    {
        "stationName": "Pollokshields West",
        "crs": "PLW"
    },
    {
        "stationName": "Polmont",
        "crs": "PMT"
    },
    {
        "stationName": "Polsloe Bridge",
        "crs": "POL"
    },
    {
        "stationName": "Ponders End",
        "crs": "PON"
    },
    {
        "stationName": "Pontarddulais",
        "crs": "PTD"
    },
    {
        "stationName": "Pontefract Baghill",
        "crs": "PFR"
    },
    {
        "stationName": "Pontefract Monkhill",
        "crs": "PFM"
    },
    {
        "stationName": "Pontefract Tanshelf",
        "crs": "POT"
    },
    {
        "stationName": "Pontlottyn",
        "crs": "PLT"
    },
    {
        "stationName": "Pontyclun",
        "crs": "PYC"
    },
    {
        "stationName": "Pont-y-Pant",
        "crs": "PYP"
    },
    {
        "stationName": "Pontypool & New Inn",
        "crs": "PPL"
    },
    {
        "stationName": "Pontypridd",
        "crs": "PPD"
    },
    {
        "stationName": "Poole",
        "crs": "POO"
    },
    {
        "stationName": "Poppleton",
        "crs": "POP"
    },
    {
        "stationName": "Port Glasgow",
        "crs": "PTG"
    },
    {
        "stationName": "Port Sunlight",
        "crs": "PSL"
    },
    {
        "stationName": "Port Talbot Parkway",
        "crs": "PTA"
    },
    {
        "stationName": "Portchester",
        "crs": "PTC"
    },
    {
        "stationName": "Porth",
        "crs": "POR"
    },
    {
        "stationName": "Porthmadog",
        "crs": "PTM"
    },
    {
        "stationName": "Portlethen",
        "crs": "PLN"
    },
    {
        "stationName": "Portslade",
        "crs": "PLD"
    },
    {
        "stationName": "Portsmouth & Southsea",
        "crs": "PMS"
    },
    {
        "stationName": "Portsmouth Arms",
        "crs": "PMA"
    },
    {
        "stationName": "Portsmouth Harbour",
        "crs": "PMH"
    },
    {
        "stationName": "Possilpark & Parkhouse",
        "crs": "PPK"
    },
    {
        "stationName": "Potters Bar",
        "crs": "PBR"
    },
    {
        "stationName": "Poulton-le-Fylde",
        "crs": "PFY"
    },
    {
        "stationName": "Poynton",
        "crs": "PYT"
    },
    {
        "stationName": "Prees",
        "crs": "PRS"
    },
    {
        "stationName": "Prescot",
        "crs": "PSC"
    },
    {
        "stationName": "Prestatyn",
        "crs": "PRT"
    },
    {
        "stationName": "Prestbury",
        "crs": "PRB"
    },
    {
        "stationName": "Preston (Lancs)",
        "crs": "PRE"
    },
    {
        "stationName": "Preston Park",
        "crs": "PRP"
    },
    {
        "stationName": "Prestonpans",
        "crs": "PST"
    },
    {
        "stationName": "Prestwick International Airport",
        "crs": "PRA"
    },
    {
        "stationName": "Prestwick Town",
        "crs": "PTW"
    },
    {
        "stationName": "Priesthill & Darnley",
        "crs": "PTL"
    },
    {
        "stationName": "Princes Risborough",
        "crs": "PRR"
    },
    {
        "stationName": "Prittlewell",
        "crs": "PRL"
    },
    {
        "stationName": "Prudhoe",
        "crs": "PRU"
    },
    {
        "stationName": "Pulborough",
        "crs": "PUL"
    },
    {
        "stationName": "Purfleet",
        "crs": "PFL"
    },
    {
        "stationName": "Purley",
        "crs": "PUR"
    },
    {
        "stationName": "Purley Oaks",
        "crs": "PUO"
    },
    {
        "stationName": "Putney",
        "crs": "PUT"
    },
    {
        "stationName": "Pwllheli",
        "crs": "PWL"
    },
    {
        "stationName": "Pye Corner",
        "crs": "PYE"
    },
    {
        "stationName": "Pyle",
        "crs": "PYL"
    },
    {
        "stationName": "Quakers Yard",
        "crs": "QYD"
    },
    {
        "stationName": "Queenborough",
        "crs": "QBR"
    },
    {
        "stationName": "Queens Park (Glasgow)",
        "crs": "QPK"
    },
    {
        "stationName": "Queens Park (London)",
        "crs": "QPW"
    },
    {
        "stationName": "Queens Road (Peckham)",
        "crs": "QRP"
    },
    {
        "stationName": "Queenstown Road (Battersea)",
        "crs": "QRB"
    },
    {
        "stationName": "Quintrell Downs",
        "crs": "QUI"
    },
    {
        "stationName": "Radcliffe-on-Trent",
        "crs": "RDF"
    },
    {
        "stationName": "Radlett",
        "crs": "RDT"
    },
    {
        "stationName": "Radley",
        "crs": "RAD"
    },
    {
        "stationName": "Radyr",
        "crs": "RDR"
    },
    {
        "stationName": "Rainford",
        "crs": "RNF"
    },
    {
        "stationName": "Rainham (Essex)",
        "crs": "RNM"
    },
    {
        "stationName": "Rainham (Kent)",
        "crs": "RAI"
    },
    {
        "stationName": "Rainhill",
        "crs": "RNH"
    },
    {
        "stationName": "Ramsgate",
        "crs": "RAM"
    },
    {
        "stationName": "Ramsgreave & Wilpshire",
        "crs": "RGW"
    },
    {
        "stationName": "Rannoch",
        "crs": "RAN"
    },
    {
        "stationName": "Rauceby",
        "crs": "RAU"
    },
    {
        "stationName": "Ravenglass for Eskdale",
        "crs": "RAV"
    },
    {
        "stationName": "Ravensbourne",
        "crs": "RVB"
    },
    {
        "stationName": "Ravensthorpe",
        "crs": "RVN"
    },
    {
        "stationName": "Rawcliffe",
        "crs": "RWC"
    },
    {
        "stationName": "Rayleigh",
        "crs": "RLG"
    },
    {
        "stationName": "Raynes Park",
        "crs": "RAY"
    },
    {
        "stationName": "Reading",
        "crs": "RDG"
    },
    {
        "stationName": "Reading West",
        "crs": "RDW"
    },
    {
        "stationName": "Rectory Road",
        "crs": "REC"
    },
    {
        "stationName": "Redbridge",
        "crs": "RDB"
    },
    {
        "stationName": "Redcar British Steel",
        "crs": "RBS"
    },
    {
        "stationName": "Redcar Central",
        "crs": "RCC"
    },
    {
        "stationName": "Redcar East",
        "crs": "RCE"
    },
    {
        "stationName": "Reddish North",
        "crs": "RDN"
    },
    {
        "stationName": "Reddish South",
        "crs": "RDS"
    },
    {
        "stationName": "Redditch",
        "crs": "RDC"
    },
    {
        "stationName": "Redhill",
        "crs": "RDH"
    },
    {
        "stationName": "Redland",
        "crs": "RDA"
    },
    {
        "stationName": "Redruth",
        "crs": "RED"
    },
    {
        "stationName": "Reedham (Norfolk)",
        "crs": "REE"
    },
    {
        "stationName": "Reedham (Surrey)",
        "crs": "RHM"
    },
    {
        "stationName": "Reigate",
        "crs": "REI"
    },
    {
        "stationName": "Renton",
        "crs": "RTN"
    },
    {
        "stationName": "Retford",
        "crs": "RET"
    },
    {
        "stationName": "Rhiwbina",
        "crs": "RHI"
    },
    {
        "stationName": "Rhoose Cardiff International Airport",
        "crs": "RIA"
    },
    {
        "stationName": "Rhosneigr",
        "crs": "RHO"
    },
    {
        "stationName": "Rhyl",
        "crs": "RHL"
    },
    {
        "stationName": "Rhymney",
        "crs": "RHY"
    },
    {
        "stationName": "Ribblehead",
        "crs": "RHD"
    },
    {
        "stationName": "Rice Lane",
        "crs": "RIL"
    },
    {
        "stationName": "Richmond (London)",
        "crs": "RMD"
    },
    {
        "stationName": "Rickmansworth",
        "crs": "RIC"
    },
    {
        "stationName": "Riddlesdown",
        "crs": "RDD"
    },
    {
        "stationName": "Ridgmont",
        "crs": "RID"
    },
    {
        "stationName": "Riding Mill",
        "crs": "RDM"
    },
    {
        "stationName": "Risca & Pontymister",
        "crs": "RCA"
    },
    {
        "stationName": "Rishton",
        "crs": "RIS"
    },
    {
        "stationName": "Robertsbridge",
        "crs": "RBR"
    },
    {
        "stationName": "Robroyston",
        "crs": "RRN"
    },
    {
        "stationName": "Roby",
        "crs": "ROB"
    },
    {
        "stationName": "Rochdale",
        "crs": "RCD"
    },
    {
        "stationName": "Roche",
        "crs": "ROC"
    },
    {
        "stationName": "Rochester",
        "crs": "RTR"
    },
    {
        "stationName": "Rochford",
        "crs": "RFD"
    },
    {
        "stationName": "Rock Ferry",
        "crs": "RFY"
    },
    {
        "stationName": "Rogart",
        "crs": "ROG"
    },
    {
        "stationName": "Rogerstone",
        "crs": "ROR"
    },
    {
        "stationName": "Rolleston",
        "crs": "ROL"
    },
    {
        "stationName": "Roman Bridge",
        "crs": "RMB"
    },
    {
        "stationName": "Romford",
        "crs": "RMF"
    },
    {
        "stationName": "Romiley",
        "crs": "RML"
    },
    {
        "stationName": "Romsey",
        "crs": "ROM"
    },
    {
        "stationName": "Roose",
        "crs": "ROO"
    },
    {
        "stationName": "Rose Grove",
        "crs": "RSG"
    },
    {
        "stationName": "Rose Hill Marple",
        "crs": "RSH"
    },
    {
        "stationName": "Rosyth",
        "crs": "ROS"
    },
    {
        "stationName": "Rotherham Central",
        "crs": "RMC"
    },
    {
        "stationName": "Rotherhithe",
        "crs": "ROE"
    },
    {
        "stationName": "Roughton Road",
        "crs": "RNR"
    },
    {
        "stationName": "Rowlands Castle",
        "crs": "RLN"
    },
    {
        "stationName": "Rowley Regis",
        "crs": "ROW"
    },
    {
        "stationName": "Roy Bridge",
        "crs": "RYB"
    },
    {
        "stationName": "Roydon",
        "crs": "RYN"
    },
    {
        "stationName": "Royston",
        "crs": "RYS"
    },
    {
        "stationName": "Ruabon",
        "crs": "RUA"
    },
    {
        "stationName": "Rufford",
        "crs": "RUF"
    },
    {
        "stationName": "Rugby",
        "crs": "RUG"
    },
    {
        "stationName": "Rugeley Town",
        "crs": "RGT"
    },
    {
        "stationName": "Rugeley Trent Valley",
        "crs": "RGL"
    },
    {
        "stationName": "Runcorn",
        "crs": "RUN"
    },
    {
        "stationName": "Runcorn East",
        "crs": "RUE"
    },
    {
        "stationName": "Ruskington",
        "crs": "RKT"
    },
    {
        "stationName": "Ruswarp",
        "crs": "RUS"
    },
    {
        "stationName": "Rutherglen",
        "crs": "RUT"
    },
    {
        "stationName": "Ryde Esplanade",
        "crs": "RYD"
    },
    {
        "stationName": "Ryde Pier Head",
        "crs": "RYP"
    },
    {
        "stationName": "Ryde St Johns Road",
        "crs": "RYR"
    },
    {
        "stationName": "Ryder Brow",
        "crs": "RRB"
    },
    {
        "stationName": "Rye (Sussex)",
        "crs": "RYE"
    },
    {
        "stationName": "Rye House",
        "crs": "RYH"
    },
    {
        "stationName": "Salford Central",
        "crs": "SFD"
    },
    {
        "stationName": "Salford Crescent",
        "crs": "SLD"
    },
    {
        "stationName": "Salfords (Surrey)",
        "crs": "SAF"
    },
    {
        "stationName": "Salhouse",
        "crs": "SAH"
    },
    {
        "stationName": "Salisbury",
        "crs": "SAL"
    },
    {
        "stationName": "Saltaire",
        "crs": "SAE"
    },
    {
        "stationName": "Saltash",
        "crs": "STS"
    },
    {
        "stationName": "Saltburn",
        "crs": "SLB"
    },
    {
        "stationName": "Saltcoats",
        "crs": "SLT"
    },
    {
        "stationName": "Saltmarshe",
        "crs": "SAM"
    },
    {
        "stationName": "Salwick",
        "crs": "SLW"
    },
    {
        "stationName": "Sampford Courtenay",
        "crs": "SMC"
    },
    {
        "stationName": "Sandal & Agbrigg",
        "crs": "SNA"
    },
    {
        "stationName": "Sandbach",
        "crs": "SDB"
    },
    {
        "stationName": "Sanderstead",
        "crs": "SNR"
    },
    {
        "stationName": "Sandhills",
        "crs": "SDL"
    },
    {
        "stationName": "Sandhurst (Berks)",
        "crs": "SND"
    },
    {
        "stationName": "Sandling",
        "crs": "SDG"
    },
    {
        "stationName": "Sandown",
        "crs": "SAN"
    },
    {
        "stationName": "Sandplace",
        "crs": "SDP"
    },
    {
        "stationName": "Sandwell & Dudley",
        "crs": "SAD"
    },
    {
        "stationName": "Sandwich",
        "crs": "SDW"
    },
    {
        "stationName": "Sandy",
        "crs": "SDY"
    },
    {
        "stationName": "Sankey for Penketh",
        "crs": "SNK"
    },
    {
        "stationName": "Sanquhar",
        "crs": "SQH"
    },
    {
        "stationName": "Sarn",
        "crs": "SRR"
    },
    {
        "stationName": "Saundersfoot",
        "crs": "SDF"
    },
    {
        "stationName": "Saunderton",
        "crs": "SDR"
    },
    {
        "stationName": "Sawbridgeworth",
        "crs": "SAW"
    },
    {
        "stationName": "Saxilby",
        "crs": "SXY"
    },
    {
        "stationName": "Saxmundham",
        "crs": "SAX"
    },
    {
        "stationName": "Scarborough",
        "crs": "SCA"
    },
    {
        "stationName": "Scotscalder",
        "crs": "SCT"
    },
    {
        "stationName": "Scotstounhill",
        "crs": "SCH"
    },
    {
        "stationName": "Scunthorpe",
        "crs": "SCU"
    },
    {
        "stationName": "Sea Mills",
        "crs": "SML"
    },
    {
        "stationName": "Seaford (Sussex)",
        "crs": "SEF"
    },
    {
        "stationName": "Seaforth & Litherland",
        "crs": "SFL"
    },
    {
        "stationName": "Seaham",
        "crs": "SEA"
    },
    {
        "stationName": "Seamer",
        "crs": "SEM"
    },
    {
        "stationName": "Seascale",
        "crs": "SSC"
    },
    {
        "stationName": "Seaton Carew",
        "crs": "SEC"
    },
    {
        "stationName": "Seer Green & Jordans",
        "crs": "SRG"
    },
    {
        "stationName": "Selby",
        "crs": "SBY"
    },
    {
        "stationName": "Selhurst",
        "crs": "SRS"
    },
    {
        "stationName": "Sellafield",
        "crs": "SEL"
    },
    {
        "stationName": "Selling",
        "crs": "SEG"
    },
    {
        "stationName": "Selly Oak",
        "crs": "SLY"
    },
    {
        "stationName": "Settle",
        "crs": "SET"
    },
    {
        "stationName": "Seven Kings",
        "crs": "SVK"
    },
    {
        "stationName": "Seven Sisters",
        "crs": "SVS"
    },
    {
        "stationName": "Sevenoaks",
        "crs": "SEV"
    },
    {
        "stationName": "Severn Beach",
        "crs": "SVB"
    },
    {
        "stationName": "Severn Tunnel Junction",
        "crs": "STJ"
    },
    {
        "stationName": "Shadwell",
        "crs": "SDE"
    },
    {
        "stationName": "Shalford (Surrey)",
        "crs": "SFR"
    },
    {
        "stationName": "Shanklin",
        "crs": "SHN"
    },
    {
        "stationName": "Shawfair",
        "crs": "SFI"
    },
    {
        "stationName": "Shawford",
        "crs": "SHW"
    },
    {
        "stationName": "Shawlands",
        "crs": "SHL"
    },
    {
        "stationName": "Sheerness-on-Sea",
        "crs": "SSS"
    },
    {
        "stationName": "Sheffield",
        "crs": "SHF"
    },
    {
        "stationName": "Shelford (Cambs)",
        "crs": "SED"
    },
    {
        "stationName": "Shenfield",
        "crs": "SNF"
    },
    {
        "stationName": "Shenstone",
        "crs": "SEN"
    },
    {
        "stationName": "Shepherd's Bush",
        "crs": "SPB"
    },
    {
        "stationName": "Shepherds Well",
        "crs": "SPH"
    },
    {
        "stationName": "Shepley",
        "crs": "SPY"
    },
    {
        "stationName": "Shepperton",
        "crs": "SHP"
    },
    {
        "stationName": "Shepreth",
        "crs": "STH"
    },
    {
        "stationName": "Sherborne",
        "crs": "SHE"
    },
    {
        "stationName": "Sherburn-in-Elmet",
        "crs": "SIE"
    },
    {
        "stationName": "Sheringham",
        "crs": "SHM"
    },
    {
        "stationName": "Shettleston",
        "crs": "SLS"
    },
    {
        "stationName": "Shieldmuir",
        "crs": "SDM"
    },
    {
        "stationName": "Shifnal",
        "crs": "SFN"
    },
    {
        "stationName": "Shildon",
        "crs": "SHD"
    },
    {
        "stationName": "Shiplake",
        "crs": "SHI"
    },
    {
        "stationName": "Shipley (Yorks)",
        "crs": "SHY"
    },
    {
        "stationName": "Shippea Hill",
        "crs": "SPP"
    },
    {
        "stationName": "Shipton",
        "crs": "SIP"
    },
    {
        "stationName": "Shirebrook",
        "crs": "SHB"
    },
    {
        "stationName": "Shirehampton",
        "crs": "SHH"
    },
    {
        "stationName": "Shireoaks",
        "crs": "SRO"
    },
    {
        "stationName": "Shirley",
        "crs": "SRL"
    },
    {
        "stationName": "Shoeburyness",
        "crs": "SRY"
    },
    {
        "stationName": "Sholing",
        "crs": "SHO"
    },
    {
        "stationName": "Shoreditch High Street",
        "crs": "SDC"
    },
    {
        "stationName": "Shoreham (Kent)",
        "crs": "SEH"
    },
    {
        "stationName": "Shoreham-by-Sea",
        "crs": "SSE"
    },
    {
        "stationName": "Shortlands",
        "crs": "SRT"
    },
    {
        "stationName": "Shotton",
        "crs": "SHT"
    },
    {
        "stationName": "Shotts",
        "crs": "SHS"
    },
    {
        "stationName": "Shrewsbury",
        "crs": "SHR"
    },
    {
        "stationName": "Sidcup",
        "crs": "SID"
    },
    {
        "stationName": "Sileby",
        "crs": "SIL"
    },
    {
        "stationName": "Silecroft",
        "crs": "SIC"
    },
    {
        "stationName": "Silkstone Common",
        "crs": "SLK"
    },
    {
        "stationName": "Silver Street",
        "crs": "SLV"
    },
    {
        "stationName": "Silverdale",
        "crs": "SVR"
    },
    {
        "stationName": "Singer",
        "crs": "SIN"
    },
    {
        "stationName": "Sittingbourne",
        "crs": "SIT"
    },
    {
        "stationName": "Skegness",
        "crs": "SKG"
    },
    {
        "stationName": "Skewen",
        "crs": "SKE"
    },
    {
        "stationName": "Skipton",
        "crs": "SKI"
    },
    {
        "stationName": "Slade Green",
        "crs": "SGR"
    },
    {
        "stationName": "Slaithwaite",
        "crs": "SWT"
    },
    {
        "stationName": "Slateford",
        "crs": "SLA"
    },
    {
        "stationName": "Sleaford",
        "crs": "SLR"
    },
    {
        "stationName": "Sleights",
        "crs": "SLH"
    },
    {
        "stationName": "Slough",
        "crs": "SLO"
    },
    {
        "stationName": "Small Heath",
        "crs": "SMA"
    },
    {
        "stationName": "Smallbrook Junction",
        "crs": "SAB"
    },
    {
        "stationName": "Smethwick Galton Bridge",
        "crs": "SGB"
    },
    {
        "stationName": "Smethwick Rolfe Street",
        "crs": "SMR"
    },
    {
        "stationName": "Smithy Bridge",
        "crs": "SMB"
    },
    {
        "stationName": "Snaith",
        "crs": "SNI"
    },
    {
        "stationName": "Snodland",
        "crs": "SDA"
    },
    {
        "stationName": "Snowdown",
        "crs": "SWO"
    },
    {
        "stationName": "Sole Street",
        "crs": "SOR"
    },
    {
        "stationName": "Solihull",
        "crs": "SOL"
    },
    {
        "stationName": "Somerleyton",
        "crs": "SYT"
    },
    {
        "stationName": "South Acton",
        "crs": "SAT"
    },
    {
        "stationName": "South Bank",
        "crs": "SBK"
    },
    {
        "stationName": "South Bermondsey",
        "crs": "SBM"
    },
    {
        "stationName": "South Croydon",
        "crs": "SCY"
    },
    {
        "stationName": "South Elmsall",
        "crs": "SES"
    },
    {
        "stationName": "South Greenford",
        "crs": "SGN"
    },
    {
        "stationName": "South Gyle",
        "crs": "SGL"
    },
    {
        "stationName": "South Hampstead",
        "crs": "SOH"
    },
    {
        "stationName": "South Kenton",
        "crs": "SOK"
    },
    {
        "stationName": "South Merton",
        "crs": "SMO"
    },
    {
        "stationName": "South Milford",
        "crs": "SOM"
    },
    {
        "stationName": "South Ruislip",
        "crs": "SRU"
    },
    {
        "stationName": "South Tottenham",
        "crs": "STO"
    },
    {
        "stationName": "South Wigston",
        "crs": "SWS"
    },
    {
        "stationName": "South Woodham Ferrers",
        "crs": "SOF"
    },
    {
        "stationName": "Southall",
        "crs": "STL"
    },
    {
        "stationName": "Southampton Airport Parkway",
        "crs": "SOA"
    },
    {
        "stationName": "Southampton Central",
        "crs": "SOU"
    },
    {
        "stationName": "Southbourne",
        "crs": "SOB"
    },
    {
        "stationName": "Southbury",
        "crs": "SBU"
    },
    {
        "stationName": "Southease",
        "crs": "SEE"
    },
    {
        "stationName": "Southend Airport",
        "crs": "SIA"
    },
    {
        "stationName": "Southend Central",
        "crs": "SOC"
    },
    {
        "stationName": "Southend East",
        "crs": "SOE"
    },
    {
        "stationName": "Southend Victoria",
        "crs": "SOV"
    },
    {
        "stationName": "Southminster",
        "crs": "SMN"
    },
    {
        "stationName": "Southport",
        "crs": "SOP"
    },
    {
        "stationName": "Southwick",
        "crs": "SWK"
    },
    {
        "stationName": "Sowerby Bridge",
        "crs": "SOW"
    },
    {
        "stationName": "Spalding",
        "crs": "SPA"
    },
    {
        "stationName": "Spean Bridge",
        "crs": "SBR"
    },
    {
        "stationName": "Spital",
        "crs": "SPI"
    },
    {
        "stationName": "Spondon",
        "crs": "SPO"
    },
    {
        "stationName": "Spooner Row",
        "crs": "SPN"
    },
    {
        "stationName": "Spring Road",
        "crs": "SRI"
    },
    {
        "stationName": "Springburn",
        "crs": "SPR"
    },
    {
        "stationName": "Springfield",
        "crs": "SPF"
    },
    {
        "stationName": "Squires Gate",
        "crs": "SQU"
    },
    {
        "stationName": "St Albans Abbey",
        "crs": "SAA"
    },
    {
        "stationName": "St Albans City",
        "crs": "SAC"
    },
    {
        "stationName": "St Andrews Road",
        "crs": "SAR"
    },
    {
        "stationName": "St Annes-on-Sea",
        "crs": "SAS"
    },
    {
        "stationName": "St Austell",
        "crs": "SAU"
    },
    {
        "stationName": "St Bees",
        "crs": "SBS"
    },
    {
        "stationName": "St Budeaux Ferry Road",
        "crs": "SBF"
    },
    {
        "stationName": "St Budeaux Victoria Road",
        "crs": "SBV"
    },
    {
        "stationName": "St Columb Road",
        "crs": "SCR"
    },
    {
        "stationName": "St Denys",
        "crs": "SDN"
    },
    {
        "stationName": "St Erth",
        "crs": "SER"
    },
    {
        "stationName": "St Germans",
        "crs": "SGM"
    },
    {
        "stationName": "St Helens Central",
        "crs": "SNH"
    },
    {
        "stationName": "St Helens Junction",
        "crs": "SHJ"
    },
    {
        "stationName": "St Helier (Surrey)",
        "crs": "SIH"
    },
    {
        "stationName": "St Ives (Cornwall)",
        "crs": "SIV"
    },
    {
        "stationName": "St James Park (Exeter)",
        "crs": "SJP"
    },
    {
        "stationName": "St James Street (Walthamstow)",
        "crs": "SJS"
    },
    {
        "stationName": "St Johns (London)",
        "crs": "SAJ"
    },
    {
        "stationName": "St Keyne Wishing Well Halt",
        "crs": "SKN"
    },
    {
        "stationName": "St Leonards Warrior Square",
        "crs": "SLQ"
    },
    {
        "stationName": "St Margarets (Herts)",
        "crs": "SMT"
    },
    {
        "stationName": "St Margarets (London)",
        "crs": "SMG"
    },
    {
        "stationName": "St Mary Cray",
        "crs": "SMY"
    },
    {
        "stationName": "St Michaels",
        "crs": "STM"
    },
    {
        "stationName": "St Neots",
        "crs": "SNO"
    },
    {
        "stationName": "Stafford",
        "crs": "STA"
    },
    {
        "stationName": "Staines",
        "crs": "SNS"
    },
    {
        "stationName": "Stallingborough",
        "crs": "SLL"
    },
    {
        "stationName": "Stalybridge",
        "crs": "SYB"
    },
    {
        "stationName": "Stamford (Lincs)",
        "crs": "SMD"
    },
    {
        "stationName": "Stamford Hill",
        "crs": "SMH"
    },
    {
        "stationName": "Stanford-le-Hope",
        "crs": "SFO"
    },
    {
        "stationName": "Stanlow & Thornton",
        "crs": "SNT"
    },
    {
        "stationName": "Stansted Airport",
        "crs": "SSD"
    },
    {
        "stationName": "Stansted Mountfitchet",
        "crs": "SST"
    },
    {
        "stationName": "Staplehurst",
        "crs": "SPU"
    },
    {
        "stationName": "Stapleton Road",
        "crs": "SRD"
    },
    {
        "stationName": "Starbeck",
        "crs": "SBE"
    },
    {
        "stationName": "Starcross",
        "crs": "SCS"
    },
    {
        "stationName": "Staveley (Cumbria)",
        "crs": "SVL"
    },
    {
        "stationName": "Stechford",
        "crs": "SCF"
    },
    {
        "stationName": "Steeton & Silsden",
        "crs": "SON"
    },
    {
        "stationName": "Stepps",
        "crs": "SPS"
    },
    {
        "stationName": "Stevenage",
        "crs": "SVG"
    },
    {
        "stationName": "Stevenston",
        "crs": "STV"
    },
    {
        "stationName": "Stewartby",
        "crs": "SWR"
    },
    {
        "stationName": "Stewarton",
        "crs": "STT"
    },
    {
        "stationName": "Stirling",
        "crs": "STG"
    },
    {
        "stationName": "Stockport",
        "crs": "SPT"
    },
    {
        "stationName": "Stocksfield",
        "crs": "SKS"
    },
    {
        "stationName": "Stocksmoor",
        "crs": "SSM"
    },
    {
        "stationName": "Stockton",
        "crs": "STK"
    },
    {
        "stationName": "Stoke Mandeville",
        "crs": "SKM"
    },
    {
        "stationName": "Stoke Newington",
        "crs": "SKW"
    },
    {
        "stationName": "Stoke-on-Trent",
        "crs": "SOT"
    },
    {
        "stationName": "Stone (Staffs)",
        "crs": "SNE"
    },
    {
        "stationName": "Stone Crossing",
        "crs": "SCG"
    },
    {
        "stationName": "Stonebridge Park",
        "crs": "SBP"
    },
    {
        "stationName": "Stonegate",
        "crs": "SOG"
    },
    {
        "stationName": "Stonehaven",
        "crs": "STN"
    },
    {
        "stationName": "Stonehouse",
        "crs": "SHU"
    },
    {
        "stationName": "Stoneleigh",
        "crs": "SNL"
    },
    {
        "stationName": "Stourbridge Junction",
        "crs": "SBJ"
    },
    {
        "stationName": "Stourbridge Town",
        "crs": "SBT"
    },
    {
        "stationName": "Stow",
        "crs": "SOI"
    },
    {
        "stationName": "Stowmarket",
        "crs": "SMK"
    },
    {
        "stationName": "Stranraer",
        "crs": "STR"
    },
    {
        "stationName": "Stratford (London)",
        "crs": "SRA"
    },
    {
        "stationName": "Stratford International",
        "crs": "SFA"
    },
    {
        "stationName": "Stratford-upon-Avon",
        "crs": "SAV"
    },
    {
        "stationName": "Stratford-upon-Avon Parkway",
        "crs": "STY"
    },
    {
        "stationName": "Strathcarron",
        "crs": "STC"
    },
    {
        "stationName": "Strawberry Hill",
        "crs": "STW"
    },
    {
        "stationName": "Streatham (Greater London)",
        "crs": "STE"
    },
    {
        "stationName": "Streatham Common",
        "crs": "SRC"
    },
    {
        "stationName": "Streatham Hill",
        "crs": "SRH"
    },
    {
        "stationName": "Streethouse",
        "crs": "SHC"
    },
    {
        "stationName": "Strines",
        "crs": "SRN"
    },
    {
        "stationName": "Stromeferry",
        "crs": "STF"
    },
    {
        "stationName": "Strood (Kent)",
        "crs": "SOO"
    },
    {
        "stationName": "Stroud (Gloucs)",
        "crs": "STD"
    },
    {
        "stationName": "Sturry",
        "crs": "STU"
    },
    {
        "stationName": "Styal",
        "crs": "SYA"
    },
    {
        "stationName": "Sudbury & Harrow Road",
        "crs": "SUD"
    },
    {
        "stationName": "Sudbury (Suffolk)",
        "crs": "SUY"
    },
    {
        "stationName": "Sudbury Hill Harrow",
        "crs": "SDH"
    },
    {
        "stationName": "Sugar Loaf",
        "crs": "SUG"
    },
    {
        "stationName": "Summerston",
        "crs": "SUM"
    },
    {
        "stationName": "Sunbury",
        "crs": "SUU"
    },
    {
        "stationName": "Sunderland",
        "crs": "SUN"
    },
    {
        "stationName": "Sundridge Park",
        "crs": "SUP"
    },
    {
        "stationName": "Sunningdale",
        "crs": "SNG"
    },
    {
        "stationName": "Sunnymeads",
        "crs": "SNY"
    },
    {
        "stationName": "Surbiton",
        "crs": "SUR"
    },
    {
        "stationName": "Surrey Quays",
        "crs": "SQE"
    },
    {
        "stationName": "Sutton (Surrey)",
        "crs": "SUO"
    },
    {
        "stationName": "Sutton Coldfield",
        "crs": "SUT"
    },
    {
        "stationName": "Sutton Common",
        "crs": "SUC"
    },
    {
        "stationName": "Sutton Parkway",
        "crs": "SPK"
    },
    {
        "stationName": "Swale",
        "crs": "SWL"
    },
    {
        "stationName": "Swanley",
        "crs": "SAY"
    },
    {
        "stationName": "Swanscombe",
        "crs": "SWM"
    },
    {
        "stationName": "Swansea",
        "crs": "SWA"
    },
    {
        "stationName": "Swanwick",
        "crs": "SNW"
    },
    {
        "stationName": "Sway",
        "crs": "SWY"
    },
    {
        "stationName": "Swaythling",
        "crs": "SWG"
    },
    {
        "stationName": "Swinderby",
        "crs": "SWD"
    },
    {
        "stationName": "Swindon (Wilts)",
        "crs": "SWI"
    },
    {
        "stationName": "Swineshead",
        "crs": "SWE"
    },
    {
        "stationName": "Swinton (Manchester)",
        "crs": "SNN"
    },
    {
        "stationName": "Swinton (South Yorks)",
        "crs": "SWN"
    },
    {
        "stationName": "Sydenham (London)",
        "crs": "SYD"
    },
    {
        "stationName": "Sydenham Hill",
        "crs": "SYH"
    },
    {
        "stationName": "Syon Lane",
        "crs": "SYL"
    },
    {
        "stationName": "Syston",
        "crs": "SYS"
    },
    {
        "stationName": "Tackley",
        "crs": "TAC"
    },
    {
        "stationName": "Tadworth",
        "crs": "TAD"
    },
    {
        "stationName": "Taffs Well",
        "crs": "TAF"
    },
    {
        "stationName": "Tain",
        "crs": "TAI"
    },
    {
        "stationName": "Talsarnau",
        "crs": "TAL"
    },
    {
        "stationName": "Talybont",
        "crs": "TLB"
    },
    {
        "stationName": "Tal-y-Cafn",
        "crs": "TLC"
    },
    {
        "stationName": "Tame Bridge Parkway",
        "crs": "TAB"
    },
    {
        "stationName": "Tamworth",
        "crs": "TAM"
    },
    {
        "stationName": "Taplow",
        "crs": "TAP"
    },
    {
        "stationName": "Tattenham Corner",
        "crs": "TAT"
    },
    {
        "stationName": "Taunton",
        "crs": "TAU"
    },
    {
        "stationName": "Taynuilt",
        "crs": "TAY"
    },
    {
        "stationName": "Teddington",
        "crs": "TED"
    },
    {
        "stationName": "Tees-side Airport",
        "crs": "TEA"
    },
    {
        "stationName": "Teignmouth",
        "crs": "TGM"
    },
    {
        "stationName": "Telford Central",
        "crs": "TFC"
    },
    {
        "stationName": "Templecombe",
        "crs": "TMC"
    },
    {
        "stationName": "Tenby",
        "crs": "TEN"
    },
    {
        "stationName": "Teynham",
        "crs": "TEY"
    },
    {
        "stationName": "Thames Ditton",
        "crs": "THD"
    },
    {
        "stationName": "Thatcham",
        "crs": "THA"
    },
    {
        "stationName": "Thatto Heath",
        "crs": "THH"
    },
    {
        "stationName": "The Hawthorns",
        "crs": "THW"
    },
    {
        "stationName": "The Lakes (Warks)",
        "crs": "TLK"
    },
    {
        "stationName": "Theale",
        "crs": "THE"
    },
    {
        "stationName": "Theobalds Grove",
        "crs": "TEO"
    },
    {
        "stationName": "Thetford",
        "crs": "TTF"
    },
    {
        "stationName": "Thirsk",
        "crs": "THI"
    },
    {
        "stationName": "Thornaby",
        "crs": "TBY"
    },
    {
        "stationName": "Thorne North",
        "crs": "TNN"
    },
    {
        "stationName": "Thorne South",
        "crs": "TNS"
    },
    {
        "stationName": "Thornford",
        "crs": "THO"
    },
    {
        "stationName": "Thornliebank",
        "crs": "THB"
    },
    {
        "stationName": "Thornton Abbey",
        "crs": "TNA"
    },
    {
        "stationName": "Thornton Heath",
        "crs": "TTH"
    },
    {
        "stationName": "Thorntonhall",
        "crs": "THT"
    },
    {
        "stationName": "Thorpe Bay",
        "crs": "TPB"
    },
    {
        "stationName": "Thorpe Culvert",
        "crs": "TPC"
    },
    {
        "stationName": "Thorpe-le-Soken",
        "crs": "TLS"
    },
    {
        "stationName": "Three Bridges",
        "crs": "TBD"
    },
    {
        "stationName": "Three Oaks",
        "crs": "TOK"
    },
    {
        "stationName": "Thurgarton",
        "crs": "THU"
    },
    {
        "stationName": "Thurnscoe",
        "crs": "THC"
    },
    {
        "stationName": "Thurso",
        "crs": "THS"
    },
    {
        "stationName": "Thurston",
        "crs": "TRS"
    },
    {
        "stationName": "Tilbury Town",
        "crs": "TIL"
    },
    {
        "stationName": "Tile Hill",
        "crs": "THL"
    },
    {
        "stationName": "Tilehurst",
        "crs": "TLH"
    },
    {
        "stationName": "Tipton",
        "crs": "TIP"
    },
    {
        "stationName": "Tir-Phil",
        "crs": "TIR"
    },
    {
        "stationName": "Tisbury",
        "crs": "TIS"
    },
    {
        "stationName": "Tiverton Parkway",
        "crs": "TVP"
    },
    {
        "stationName": "Todmorden",
        "crs": "TOD"
    },
    {
        "stationName": "Tolworth",
        "crs": "TOL"
    },
    {
        "stationName": "Ton Pentre",
        "crs": "TPN"
    },
    {
        "stationName": "Tonbridge",
        "crs": "TON"
    },
    {
        "stationName": "Tondu",
        "crs": "TDU"
    },
    {
        "stationName": "Tonfanau",
        "crs": "TNF"
    },
    {
        "stationName": "Tonypandy",
        "crs": "TNP"
    },
    {
        "stationName": "Tooting",
        "crs": "TOO"
    },
    {
        "stationName": "Topsham",
        "crs": "TOP"
    },
    {
        "stationName": "Torquay",
        "crs": "TQY"
    },
    {
        "stationName": "Torre",
        "crs": "TRR"
    },
    {
        "stationName": "Totnes",
        "crs": "TOT"
    },
    {
        "stationName": "Tottenham Hale",
        "crs": "TOM"
    },
    {
        "stationName": "Totton",
        "crs": "TTN"
    },
    {
        "stationName": "Town Green",
        "crs": "TWN"
    },
    {
        "stationName": "Trafford Park",
        "crs": "TRA"
    },
    {
        "stationName": "Trefforest",
        "crs": "TRF"
    },
    {
        "stationName": "Trefforest Estate",
        "crs": "TRE"
    },
    {
        "stationName": "Trehafod",
        "crs": "TRH"
    },
    {
        "stationName": "Treherbert",
        "crs": "TRB"
    },
    {
        "stationName": "Treorchy",
        "crs": "TRY"
    },
    {
        "stationName": "Trimley",
        "crs": "TRM"
    },
    {
        "stationName": "Tring",
        "crs": "TRI"
    },
    {
        "stationName": "Troed-y-rhiw",
        "crs": "TRD"
    },
    {
        "stationName": "Troon",
        "crs": "TRN"
    },
    {
        "stationName": "Trowbridge",
        "crs": "TRO"
    },
    {
        "stationName": "Truro",
        "crs": "TRU"
    },
    {
        "stationName": "Tulloch",
        "crs": "TUL"
    },
    {
        "stationName": "Tulse Hill",
        "crs": "TUH"
    },
    {
        "stationName": "Tunbridge Wells",
        "crs": "TBW"
    },
    {
        "stationName": "Turkey Street",
        "crs": "TUR"
    },
    {
        "stationName": "Tutbury & Hatton",
        "crs": "TUT"
    },
    {
        "stationName": "Tweedbank",
        "crs": "TWB"
    },
    {
        "stationName": "Twickenham",
        "crs": "TWI"
    },
    {
        "stationName": "Twyford",
        "crs": "TWY"
    },
    {
        "stationName": "Ty Croes",
        "crs": "TYC"
    },
    {
        "stationName": "Ty Glas",
        "crs": "TGS"
    },
    {
        "stationName": "Tygwyn",
        "crs": "TYG"
    },
    {
        "stationName": "Tyndrum Lower",
        "crs": "TYL"
    },
    {
        "stationName": "Tyseley",
        "crs": "TYS"
    },
    {
        "stationName": "Tywyn",
        "crs": "TYW"
    },
    {
        "stationName": "Uckfield",
        "crs": "UCK"
    },
    {
        "stationName": "Uddingston",
        "crs": "UDD"
    },
    {
        "stationName": "Ulceby",
        "crs": "ULC"
    },
    {
        "stationName": "Ulleskelf",
        "crs": "ULL"
    },
    {
        "stationName": "Ulverston",
        "crs": "ULV"
    },
    {
        "stationName": "Umberleigh",
        "crs": "UMB"
    },
    {
        "stationName": "University (Birmingham)",
        "crs": "UNI"
    },
    {
        "stationName": "Uphall",
        "crs": "UHA"
    },
    {
        "stationName": "Upholland",
        "crs": "UPL"
    },
    {
        "stationName": "Upminster",
        "crs": "UPM"
    },
    {
        "stationName": "Upper Halliford",
        "crs": "UPH"
    },
    {
        "stationName": "Upper Holloway",
        "crs": "UHL"
    },
    {
        "stationName": "Upper Tyndrum",
        "crs": "UTY"
    },
    {
        "stationName": "Upper Warlingham",
        "crs": "UWL"
    },
    {
        "stationName": "Upton (Merseyside)",
        "crs": "UPT"
    },
    {
        "stationName": "Upwey",
        "crs": "UPW"
    },
    {
        "stationName": "Urmston",
        "crs": "URM"
    },
    {
        "stationName": "Uttoxeter",
        "crs": "UTT"
    },
    {
        "stationName": "Valley",
        "crs": "VAL"
    },
    {
        "stationName": "Vauxhall",
        "crs": "VXH"
    },
    {
        "stationName": "Virginia Water",
        "crs": "VIR"
    },
    {
        "stationName": "Waddon",
        "crs": "WDO"
    },
    {
        "stationName": "Wadhurst",
        "crs": "WAD"
    },
    {
        "stationName": "Wainfleet",
        "crs": "WFL"
    },
    {
        "stationName": "Wakefield Kirkgate",
        "crs": "WKK"
    },
    {
        "stationName": "Wakefield Westgate",
        "crs": "WKF"
    },
    {
        "stationName": "Walkden",
        "crs": "WKD"
    },
    {
        "stationName": "Wallasey Grove Road",
        "crs": "WLG"
    },
    {
        "stationName": "Wallasey Village",
        "crs": "WLV"
    },
    {
        "stationName": "Wallington",
        "crs": "WLT"
    },
    {
        "stationName": "Wallyford",
        "crs": "WAF"
    },
    {
        "stationName": "Walmer",
        "crs": "WAM"
    },
    {
        "stationName": "Walsall",
        "crs": "WSL"
    },
    {
        "stationName": "Walsden",
        "crs": "WDN"
    },
    {
        "stationName": "Waltham Cross",
        "crs": "WLC"
    },
    {
        "stationName": "Walthamstow Central",
        "crs": "WHC"
    },
    {
        "stationName": "Walthamstow Queen's Road",
        "crs": "WMW"
    },
    {
        "stationName": "Walton (Merseyside)",
        "crs": "WAO"
    },
    {
        "stationName": "Walton-on-Thames",
        "crs": "WAL"
    },
    {
        "stationName": "Walton-on-the-Naze",
        "crs": "WON"
    },
    {
        "stationName": "Wanborough",
        "crs": "WAN"
    },
    {
        "stationName": "Wandsworth Common",
        "crs": "WSW"
    },
    {
        "stationName": "Wandsworth Road",
        "crs": "WWR"
    },
    {
        "stationName": "Wandsworth Town",
        "crs": "WNT"
    },
    {
        "stationName": "Wanstead Park",
        "crs": "WNP"
    },
    {
        "stationName": "Wapping",
        "crs": "WPE"
    },
    {
        "stationName": "Warblington",
        "crs": "WBL"
    },
    {
        "stationName": "Ware (Herts)",
        "crs": "WAR"
    },
    {
        "stationName": "Wareham (Dorset)",
        "crs": "WRM"
    },
    {
        "stationName": "Wargrave",
        "crs": "WGV"
    },
    {
        "stationName": "Warminster",
        "crs": "WMN"
    },
    {
        "stationName": "Warnham",
        "crs": "WNH"
    },
    {
        "stationName": "Warrington Bank Quay",
        "crs": "WBQ"
    },
    {
        "stationName": "Warrington Central",
        "crs": "WAC"
    },
    {
        "stationName": "Warrington West",
        "crs": "WAW"
    },
    {
        "stationName": "Warwick",
        "crs": "WRW"
    },
    {
        "stationName": "Warwick Parkway",
        "crs": "WRP"
    },
    {
        "stationName": "Water Orton",
        "crs": "WTO"
    },
    {
        "stationName": "Waterbeach",
        "crs": "WBC"
    },
    {
        "stationName": "Wateringbury",
        "crs": "WTR"
    },
    {
        "stationName": "Waterloo (Merseyside)",
        "crs": "WLO"
    },
    {
        "stationName": "Watford High Street",
        "crs": "WFH"
    },
    {
        "stationName": "Watford Junction",
        "crs": "WFJ"
    },
    {
        "stationName": "Watford North",
        "crs": "WFN"
    },
    {
        "stationName": "Watlington",
        "crs": "WTG"
    },
    {
        "stationName": "Watton-at-Stone",
        "crs": "WAS"
    },
    {
        "stationName": "Waun-Gron Park",
        "crs": "WNG"
    },
    {
        "stationName": "Wavertree Technology Park",
        "crs": "WAV"
    },
    {
        "stationName": "Wedgwood",
        "crs": "WED"
    },
    {
        "stationName": "Weeley",
        "crs": "WEE"
    },
    {
        "stationName": "Weeton",
        "crs": "WET"
    },
    {
        "stationName": "Welham Green",
        "crs": "WMG"
    },
    {
        "stationName": "Welling",
        "crs": "WLI"
    },
    {
        "stationName": "Wellingborough",
        "crs": "WEL"
    },
    {
        "stationName": "Wellington (Shropshire)",
        "crs": "WLN"
    },
    {
        "stationName": "Welshpool",
        "crs": "WLP"
    },
    {
        "stationName": "Welwyn Garden City",
        "crs": "WGC"
    },
    {
        "stationName": "Welwyn North",
        "crs": "WLW"
    },
    {
        "stationName": "Wem",
        "crs": "WEM"
    },
    {
        "stationName": "Wembley Central",
        "crs": "WMB"
    },
    {
        "stationName": "Wembley Stadium",
        "crs": "WCX"
    },
    {
        "stationName": "Wemyss Bay",
        "crs": "WMS"
    },
    {
        "stationName": "Wendover",
        "crs": "WND"
    },
    {
        "stationName": "Wennington",
        "crs": "WNN"
    },
    {
        "stationName": "West Allerton",
        "crs": "WSA"
    },
    {
        "stationName": "West Brompton",
        "crs": "WBP"
    },
    {
        "stationName": "West Byfleet",
        "crs": "WBY"
    },
    {
        "stationName": "West Calder",
        "crs": "WCL"
    },
    {
        "stationName": "West Croydon",
        "crs": "WCY"
    },
    {
        "stationName": "West Drayton",
        "crs": "WDT"
    },
    {
        "stationName": "West Dulwich",
        "crs": "WDU"
    },
    {
        "stationName": "West Ealing",
        "crs": "WEA"
    },
    {
        "stationName": "West Ham",
        "crs": "WEH"
    },
    {
        "stationName": "West Hampstead",
        "crs": "WHD"
    },
    {
        "stationName": "West Hampstead Thameslink",
        "crs": "WHP"
    },
    {
        "stationName": "West Horndon",
        "crs": "WHR"
    },
    {
        "stationName": "West Kilbride",
        "crs": "WKB"
    },
    {
        "stationName": "West Kirby",
        "crs": "WKI"
    },
    {
        "stationName": "West Malling",
        "crs": "WMA"
    },
    {
        "stationName": "West Norwood",
        "crs": "WNW"
    },
    {
        "stationName": "West Ruislip",
        "crs": "WRU"
    },
    {
        "stationName": "West Runton",
        "crs": "WRN"
    },
    {
        "stationName": "West St Leonards",
        "crs": "WLD"
    },
    {
        "stationName": "West Sutton",
        "crs": "WSU"
    },
    {
        "stationName": "West Wickham",
        "crs": "WWI"
    },
    {
        "stationName": "West Worthing",
        "crs": "WWO"
    },
    {
        "stationName": "Westbury (Wilts)",
        "crs": "WSB"
    },
    {
        "stationName": "Westcliff",
        "crs": "WCF"
    },
    {
        "stationName": "Westcombe Park",
        "crs": "WCB"
    },
    {
        "stationName": "Westenhanger",
        "crs": "WHA"
    },
    {
        "stationName": "Wester Hailes",
        "crs": "WTA"
    },
    {
        "stationName": "Westerfield",
        "crs": "WFI"
    },
    {
        "stationName": "Westerton",
        "crs": "WES"
    },
    {
        "stationName": "Westgate-on-Sea",
        "crs": "WGA"
    },
    {
        "stationName": "Westhoughton",
        "crs": "WHG"
    },
    {
        "stationName": "Weston Milton",
        "crs": "WNM"
    },
    {
        "stationName": "Weston-super-Mare",
        "crs": "WSM"
    },
    {
        "stationName": "Wetheral",
        "crs": "WRL"
    },
    {
        "stationName": "Weybridge",
        "crs": "WYB"
    },
    {
        "stationName": "Weymouth",
        "crs": "WEY"
    },
    {
        "stationName": "Whaley Bridge",
        "crs": "WBR"
    },
    {
        "stationName": "Whalley (Lancs)",
        "crs": "WHE"
    },
    {
        "stationName": "Whatstandwell",
        "crs": "WTS"
    },
    {
        "stationName": "Whifflet",
        "crs": "WFF"
    },
    {
        "stationName": "Whimple",
        "crs": "WHM"
    },
    {
        "stationName": "Whinhill",
        "crs": "WNL"
    },
    {
        "stationName": "Whiston",
        "crs": "WHN"
    },
    {
        "stationName": "Whitby",
        "crs": "WTB"
    },
    {
        "stationName": "Whitchurch (Cardiff)",
        "crs": "WHT"
    },
    {
        "stationName": "Whitchurch (Hants)",
        "crs": "WCH"
    },
    {
        "stationName": "Whitchurch (Shropshire)",
        "crs": "WTC"
    },
    {
        "stationName": "White Hart Lane",
        "crs": "WHL"
    },
    {
        "stationName": "White Notley",
        "crs": "WNY"
    },
    {
        "stationName": "Whitechapel",
        "crs": "ZLW"
    },
    {
        "stationName": "Whitecraigs",
        "crs": "WCR"
    },
    {
        "stationName": "Whitehaven",
        "crs": "WTH"
    },
    {
        "stationName": "Whitland",
        "crs": "WTL"
    },
    {
        "stationName": "Whitley Bridge",
        "crs": "WBD"
    },
    {
        "stationName": "Whitlocks End",
        "crs": "WTE"
    },
    {
        "stationName": "Whitstable",
        "crs": "WHI"
    },
    {
        "stationName": "Whittlesea",
        "crs": "WLE"
    },
    {
        "stationName": "Whittlesford Parkway",
        "crs": "WLF"
    },
    {
        "stationName": "Whitton (London)",
        "crs": "WTN"
    },
    {
        "stationName": "Whitwell (Derbyshire)",
        "crs": "WWL"
    },
    {
        "stationName": "Whyteleafe",
        "crs": "WHY"
    },
    {
        "stationName": "Whyteleafe South",
        "crs": "WHS"
    },
    {
        "stationName": "Wick",
        "crs": "WCK"
    },
    {
        "stationName": "Wickford",
        "crs": "WIC"
    },
    {
        "stationName": "Wickham Market",
        "crs": "WCM"
    },
    {
        "stationName": "Widdrington",
        "crs": "WDD"
    },
    {
        "stationName": "Widnes",
        "crs": "WID"
    },
    {
        "stationName": "Widney Manor",
        "crs": "WMR"
    },
    {
        "stationName": "Wigan North Western",
        "crs": "WGN"
    },
    {
        "stationName": "Wigan Wallgate",
        "crs": "WGW"
    },
    {
        "stationName": "Wigton",
        "crs": "WGT"
    },
    {
        "stationName": "Wildmill",
        "crs": "WMI"
    },
    {
        "stationName": "Willesden Junction",
        "crs": "WIJ"
    },
    {
        "stationName": "Williamwood",
        "crs": "WLM"
    },
    {
        "stationName": "Willington",
        "crs": "WIL"
    },
    {
        "stationName": "Wilmcote",
        "crs": "WMC"
    },
    {
        "stationName": "Wilmslow",
        "crs": "WML"
    },
    {
        "stationName": "Wilnecote (Staffs)",
        "crs": "WNE"
    },
    {
        "stationName": "Wimbledon",
        "crs": "WIM"
    },
    {
        "stationName": "Wimbledon Chase",
        "crs": "WBO"
    },
    {
        "stationName": "Winchelsea",
        "crs": "WSE"
    },
    {
        "stationName": "Winchester",
        "crs": "WIN"
    },
    {
        "stationName": "Winchfield",
        "crs": "WNF"
    },
    {
        "stationName": "Winchmore Hill",
        "crs": "WIH"
    },
    {
        "stationName": "Windermere",
        "crs": "WDM"
    },
    {
        "stationName": "Windsor & Eton Central",
        "crs": "WNC"
    },
    {
        "stationName": "Windsor & Eton Riverside",
        "crs": "WNR"
    },
    {
        "stationName": "Winnersh",
        "crs": "WNS"
    },
    {
        "stationName": "Winnersh Triangle",
        "crs": "WTI"
    },
    {
        "stationName": "Winsford",
        "crs": "WSF"
    },
    {
        "stationName": "Wishaw",
        "crs": "WSH"
    },
    {
        "stationName": "Witham",
        "crs": "WTM"
    },
    {
        "stationName": "Witley",
        "crs": "WTY"
    },
    {
        "stationName": "Witton (West Midlands)",
        "crs": "WTT"
    },
    {
        "stationName": "Wivelsfield",
        "crs": "WVF"
    },
    {
        "stationName": "Wivenhoe",
        "crs": "WIV"
    },
    {
        "stationName": "Woburn Sands",
        "crs": "WOB"
    },
    {
        "stationName": "Woking",
        "crs": "WOK"
    },
    {
        "stationName": "Wokingham",
        "crs": "WKM"
    },
    {
        "stationName": "Woldingham",
        "crs": "WOH"
    },
    {
        "stationName": "Wolverhampton",
        "crs": "WVH"
    },
    {
        "stationName": "Wolverton",
        "crs": "WOL"
    },
    {
        "stationName": "Wombwell",
        "crs": "WOM"
    },
    {
        "stationName": "Wood End",
        "crs": "WDE"
    },
    {
        "stationName": "Wood Street",
        "crs": "WST"
    },
    {
        "stationName": "Woodbridge",
        "crs": "WDB"
    },
    {
        "stationName": "Woodgrange Park",
        "crs": "WGR"
    },
    {
        "stationName": "Woodhall",
        "crs": "WDL"
    },
    {
        "stationName": "Woodhouse",
        "crs": "WDH"
    },
    {
        "stationName": "Woodlesford",
        "crs": "WDS"
    },
    {
        "stationName": "Woodley",
        "crs": "WLY"
    },
    {
        "stationName": "Woodmansterne",
        "crs": "WME"
    },
    {
        "stationName": "Woodsmoor",
        "crs": "WSR"
    },
    {
        "stationName": "Wool",
        "crs": "WOO"
    },
    {
        "stationName": "Woolston",
        "crs": "WLS"
    },
    {
        "stationName": "Woolwich Arsenal",
        "crs": "WWA"
    },
    {
        "stationName": "Woolwich Dockyard",
        "crs": "WWD"
    },
    {
        "stationName": "Wootton Wawen",
        "crs": "WWW"
    },
    {
        "stationName": "Worcester Foregate Street",
        "crs": "WOF"
    },
    {
        "stationName": "Worcester Park",
        "crs": "WCP"
    },
    {
        "stationName": "Worcester Shrub Hill",
        "crs": "WOS"
    },
    {
        "stationName": "Worcestershire Parkway",
        "crs": "WOP"
    },
    {
        "stationName": "Workington",
        "crs": "WKG"
    },
    {
        "stationName": "Worksop",
        "crs": "WRK"
    },
    {
        "stationName": "Worle",
        "crs": "WOR"
    },
    {
        "stationName": "Worplesdon",
        "crs": "WPL"
    },
    {
        "stationName": "Worstead",
        "crs": "WRT"
    },
    {
        "stationName": "Worthing",
        "crs": "WRH"
    },
    {
        "stationName": "Wrabness",
        "crs": "WRB"
    },
    {
        "stationName": "Wraysbury",
        "crs": "WRY"
    },
    {
        "stationName": "Wrenbury",
        "crs": "WRE"
    },
    {
        "stationName": "Wressle",
        "crs": "WRS"
    },
    {
        "stationName": "Wrexham Central",
        "crs": "WXC"
    },
    {
        "stationName": "Wrexham General",
        "crs": "WRX"
    },
    {
        "stationName": "Wye",
        "crs": "WYE"
    },
    {
        "stationName": "Wylam",
        "crs": "WYM"
    },
    {
        "stationName": "Wylde Green",
        "crs": "WYL"
    },
    {
        "stationName": "Wymondham",
        "crs": "WMD"
    },
    {
        "stationName": "Wythall",
        "crs": "WYT"
    },
    {
        "stationName": "Yalding",
        "crs": "YAL"
    },
    {
        "stationName": "Yardley Wood",
        "crs": "YRD"
    },
    {
        "stationName": "Yarm",
        "crs": "YRM"
    },
    {
        "stationName": "Yate",
        "crs": "YAE"
    },
    {
        "stationName": "Yatton",
        "crs": "YAT"
    },
    {
        "stationName": "Yeoford",
        "crs": "YEO"
    },
    {
        "stationName": "Yeovil Junction",
        "crs": "YVJ"
    },
    {
        "stationName": "Yeovil Pen Mill",
        "crs": "YVP"
    },
    {
        "stationName": "Yetminster",
        "crs": "YET"
    },
    {
        "stationName": "Ynyswen",
        "crs": "YNW"
    },
    {
        "stationName": "Yoker",
        "crs": "YOK"
    },
    {
        "stationName": "York",
        "crs": "YRK"
    },
    {
        "stationName": "Yorton",
        "crs": "YRT"
    },
    {
        "stationName": "Ystrad Mynach",
        "crs": "YSM"
    },
    {
        "stationName": "Ystrad Rhondda",
        "crs": "YSR"
    }
]
